firebird.controller('headerCtrl', [
    '$rootScope',
    '$scope',
    '$q',
    'attendeeListService',
    'logService',
    '$window',
    '$document',
    'cookieService',
    'socketService',
    'attendeeService',
    'customerSupportService',
    'recordingService',
    'notificationService',
    'config',
    'vertoService',
    'helperService',
    'meetingAPIService',
    'meetingService',
    'configService',
    'screenShareService',
    'contentService',
    'analyticsWrapperService',
    'capabilityService',
    '$timeout',
    'connectivityService',
    'pollingService',
    'questionService',
    'supportLinkService',
    'camaroService',
    '$filter',
    'avDeviceService',
    'avDeviceSettingsService',
    'storageService',
    'localStreamManagerService',
    'mobileAVDeviceService',
    'annotationService',
    'localizationService',
    'brandingService',
    'onboardingService',
    'videoroomService',
    'virtualBackgroundService',
    'videoFilterService',
    'themedFeaturesService',
    'uniteNotificationService',
    'handRaiseService',
    'vdiService',
    'executionEnvironmentEnum',
    'subscriptionService',
    'userPairStateService',
    'modalHelperService',
    'macSecurityPreferencesService',
    function (
        $rootScope,
        $scope,
        $q,
        attendeeListService,
        logService,
        $window,
        $document,
        cookieService,
        socketService,
        attendeeService,
        customerSupportService,
        recordingService,
        notificationService,
        config,
        vertoService,
        helperService,
        meetingAPIService,
        meetingService,
        configService,
        screenShareService,
        contentService,
        analyticsWrapperService,
        capabilityService,
        $timeout,
        connectivityService,
        pollingService,
        questionService,
        supportLinkService,
        camaroService,
        $filter,
        avDeviceService,
        avDeviceSettingsService,
        storageService,
        localStreamManagerService,
        mobileAVDeviceService,
        annotationService,
        localizationService,
        brandingService,
        onboardingService,
        videoroomService,
        virtualBackgroundService,
        videoFilterService,
        themedFeaturesService,
        uniteNotificationService,
        handRaiseService,
        vdiService,
        executionEnvironmentEnum,
        subscriptionService,
        userPairStateService,
        modalHelperService,
        macSecurityPreferencesService
    ) {
        const self = this;
        const logger = new LogServiceWrapper(logService, 'headerCtrl');

        // Images to preload
        let images = [];

        // General
        self.hasWebRTC = helperService.browserHasWebRTC();
        self.isHost = attendeeService.getIsHost(true);
        self.attendantId = attendeeService.getAttendantId();
        self.getConnectingToDisplayText = getConnectingToDisplayText;
        self.getCameraTooltip = getCameraTooltip;
        self.getMicrophoneToolTip = getMicrophoneToolTip;
        self.getScreenShareTooltip = getScreenShareTooltip;
        self.getScreenShareOptionsTooltip = getScreenShareOptionsTooltip;
        self.getshareContentToolTip = getshareContentToolTip;
        self.getShareVideoTooltip = getShareVideoTooltip;
        self.getToggleRecordingToolTip = getToggleRecordingToolTip;
        self.getVirtualAssistantTooltip = getVirtualAssistantTooltip;
        self.getLockTooltip = getLockTooltip;
        self.getLocalConnectivityStateTooltip = getLocalConnectivityStateTooltip;
        self.getConnectivityTooltip = getConnectivityTooltip;
        self.getEndMeetingTooltip = getEndMeetingTooltip;
        self.getOnAirIndicatorTooltip = getOnAirIndicatorTooltip;
        self.getSwitchToPhoneTooltip = getSwitchToPhoneTooltip;
        self.getLocalConnectivityState = connectivityService.getLocalConnectivityState;
        self.hasLocalMediaEverBeenConnected = connectivityService.hasLocalMediaEverBeenConnected;
        self.leaveMeeting = leaveMeeting;
        self.performLeaveMeeting = performLeaveMeeting;
        self.openHelpMenuWebinar = openHelpMenuWebinar;
        self.openHelpMenuMeeting = openHelpMenuMeeting;
        self.endMeeting = endMeeting;
        self.onEndMeetingRedirect = onEndMeetingRedirect;
        self.isAttendeeConnected = isAttendeeConnected;

        self.hasMicrophoneDeviceError = hasMicrophoneDeviceError;
        self.isMicrophoneHavingAnIssue = isMicrophoneHavingAnIssue;
        self.isWebcamHavingAnIssue = isWebcamHavingAnIssue;
        self.hasWebcamDeviceError = hasWebcamDeviceError;

        self.hasFeatureFlags = configService.getHasFeatureFlags();
        self.toggleFeatureFlags = toggleFeatureFlags;
        self.sfuEnabled = meetingService.getIsSfuEnabled() && helperService.getIsRedesign();

        self.openAppCuesTutorial = openAppCuesTutorial;
        self.openWebinarsTutorial = openWebinarsTutorial;
        self.openOurSupportSite = openOurSupportSite;
        self.startDiagnosticProcess = startDiagnosticProcess;
        self.reportAudioVideoQuality = reportAudioVideoQuality;
        self.shouldShowReportAudioVideoQuality = attendeeService.shouldUseCallstatSurvey;
        self.openCustomerSupport = openCustomerSupport;
        self.shouldShowCustomerSupportLiveChat = shouldShowCustomerSupportLiveChat;
        self.email = attendeeService.getEmail();
        self.isMobile = helperService.isMobile();
        self.isTablet = helperService.isTablet();
        self.isIOS = helperService.getDevicePlatform() === 'iOS';
        self.isAndroidBrowser = !helperService.isMobile() && helperService.getDeviceType() === 'Android';
        self.isLeftAligned = helperService.isMobile() && !helperService.isTablet();

        self.lockMeetingAllowed = false;
        self.meetingLocked = meetingService.getLocked();
        self.isMeetingLockedInitialized = isMeetingLockedInitialized;
        self.onMeetingLockedToggled = onMeetingLockedToggled;
        self.shouldShowLockMeeting = shouldShowLockMeeting;
        self.isWaitingForMeetingLock = meetingService.getIsWaitingForLockUpdate;

        self.shouldShowSecurityToggle = shouldShowSecurityToggle;
        self.getSecurityToggleTooltip = getSecurityToggleTooltip;
        self.isSecurityToggleDisabled = isSecurityToggleDisabled;
        self.e2eeEnabled = e2eeEnabled;
        self.hasE2EEUnsupportedMobileAppUsers = hasE2EEUnsupportedMobileAppUsers;
        self.hostIsOnPhoneAudio = hostIsOnPhoneAudio;
        self.isE2EEUsersLimitReached = isE2EEUsersLimitReached;
        // this function is triggered when click on the icon in header
        self.onSecurityToggled = onSecurityToggled;
        // this function is triggered when turn on e2ee in LABS
        self.onE2EEToggled = onE2EEToggled;

        self.isHeaderVisible = isHeaderVisible;
        self.isTalkingWhileMutedNotificationVisible = isTalkingWhileMutedNotificationVisible;
        self.showTalkingWhileMutedNotification = showTalkingWhileMutedNotification;
        self.hideTalkingWhileMutedNotification = hideTalkingWhileMutedNotification;
        self.applyTalkingWhileMutedNotificationClosehandler = applyTalkingWhileMutedNotificationClosehandler;
        self.applyTalkingWhileMutedHiddenHeaderNotificationClosehandler =
            applyTalkingWhileMutedHiddenHeaderNotificationClosehandler;

        self.connectivity = {
            state: 'disconnected' /* connecting, connected, disconnected */,
            packetLossState: 'low' /* low, medium, high */
        };
        self.getConnectivityIconState = getConnectivityIconState;
        self.getConnectivityClass = getConnectivityClass;
        self.getMeetingType = getMeetingType;
        self.shouldShowConnectivityIcon = shouldShowConnectivityIcon;

        self.onFSConnectionComplete = onFSConnectionComplete;

        self.phoneOnlyState = false;

        self.isPresenter = isPresenter;
        self.isWebinar = isWebinar;
        self.isWebinarAttendee = isWebinarAttendee;
        self.isOnAir = isOnAir;
        self.isConferenceConnected = isConferenceConnected;

        self.onSnapEngageAgentStatus = onSnapEngageAgentStatus;
        self.snapEngageAgentStatus = false;

        self.getActiveDeviceLabels = getActiveDeviceLabels;
        self.activeAudioInputLabel = '';
        self.activeAudioOutputLabel = '';

        self.showWebinarsTutorialButton = attendeeService.getIsHost();

        self.attachTooltipHideListeners = attachTooltipHideListeners;

        //Device Dropdowns
        self.isDeviceDropdownEnabled = isDeviceDropdownEnabled;
        self.isDeviceDropdownActive = isDeviceDropdownActive;
        self.attachDeviceDropdownEventListeners = attachDeviceDropdownEventListeners;
        self.onDeviceDropdownToggled = onDeviceDropdownToggled;
        self.toggleDeviceDropdown = toggleDeviceDropdown;
        self.isDeviceDropdownOpen = isDeviceDropdownOpen;
        self.testAudioOutput = testAudioOutput;
        self.openAVSettings = openAVSettings;
        self.switchToDevice = switchToDevice;
        self.populateDeviceList = populateDeviceList;
        self.clearDeviceList = clearDeviceList;
        self.isVideoStreamActive = isVideoStreamActive;
        self.stopPropagation = stopPropagation;
        self.microphoneDevices = [];
        self.speakerDevices = [];
        self.webcamDevices = [];
        self.speakerTestSource = avDeviceService.getAudioOutputTestSource();
        self.devicesLoading = {
            audioInput: false,
            audioOutput: false,
            videoInput: false
        };
        // VDI only
        self.isVideoDeviceDropdownOpen = false;
        self.isWebcamAvailable = true;

        // Audio
        self.toggleAudio = toggleAudio;
        self.isAudioMuted = attendeeService.getIsAudioMuted();
        self.hasMicrophone = hasMicrophone;
        self.toggleMicClick = toggleMicClick;
        self.toggleMicInternal = toggleMicInternal;
        self.getMicrophoneDisplayClass = getMicrophoneDisplayClass;
        self.getMicrophoneDisplaySrc = getMicrophoneDisplaySrc;
        self.isMicUsable = isMicUsable;
        self.getIsTalking = getIsTalking;
        self.isTalking = false;
        self.showSwitchToMic = showSwitchToMic;
        self.showDialInInfo = showDialInInfo;
        self.isTelephonePaired = isTelephonePaired;

        self.usingTelephone = usingTelephone;
        self.toggleTelephoneAudio = toggleTelephoneAudio;

        // Video
        self.toggleVideo = toggleVideo;
        self.isVideoMuted = attendeeService.getIsVideoMuted();
        self.hasCamera = hasCamera;
        self.toggleCamClick = toggleCamClick;
        self.toggleCamInternal = toggleCamInternal;
        self.maxVideoFeedReached = false;
        self.maxVideoFeedReachedCount = 12; // default count that is updated by the server later
        self.getCameraDisplayClass = getCameraDisplayClass;
        self.hideVideosInMeetingVDI = hideVideosInMeetingVDI;
        self.showVideosInMeetingVDI = showVideosInMeetingVDI;
        self.shouldCloseWebcamDropdown = shouldCloseWebcamDropdown;

        // Recording
        self.toggleRecording = toggleRecording;
        self.isRecordingEnabled = isRecordingEnabled;
        self.isRecording = recordingService.isRecording;
        self.firstTimeRecording = true;

        // Virtual Assistant
        self.addVirtualAssistant = addVirtualAssistant;
        self.transcriptionActive = attendeeListService.hasTranscriptionBot;
        self.showVirtualAssistantLanguageSelection = showVirtualAssistantLanguageSelection;
        self.shouldStartVirtualAssistantOnHostJoin = shouldStartVirtualAssistantOnHostJoin;
        self.virtualAssistantWasRunOnHostJoin = false;

        // ScreenShare/Content
        self.isContentInitiating = false;
        self.isContentOwner = false;
        self.isScreenShareConnected = false;
        self.isFilePlay = false;
        self.toggleScreenShare = toggleScreenShare;
        self.preToggleScreenShareCheck = preToggleScreenShareCheck;
        self.hasScreenShareBrowser = helperService.hasScreenShareBrowser();
        self.hasScreenShareOS = helperService.hasScreenShareOS();
        self.hasShareVideo = hasShareVideo;

        // VDI only
        self.isScreenShareReadyToInitialize = false;
        self.isVDIScreenShareConnected = false;
        self.resetScreenShareReadyToInitialize = resetScreenShareReadyToInitialize;

        // multishare user pair related
        self.hasMultishare = configService.getHasMultishare();
        self.isScreenVideo = false; // client is sending screen video
        self.multishareRecord = configService.getServerValue('multishareRecord');
        self.getHasMultishare = getHasMultishare;

        self.more_switchToMic_click = more_switchToMic_click;
        self.more_switchToPhone_click = more_switchToPhone_click;
        self.more_audioVideoOption_click = more_audioVideoOption_click;
        self.more_webinarOptions_click = more_webinarOptions_click;

        // Content Library
        self.showContentLibrary = showContentLibrary;
        self.initiateLocalFileShare = initiateLocalFileShare;
        self.shouldShowShareContent = shouldShowShareContent;
        self.shouldShowShareDesktop = shouldShowShareDesktop;
        self.shouldHideCameraIcon = shouldHideCameraIcon;
        self.shouldShowToggleMore = shouldShowToggleMore;
        self.shouldShowSwitchToPhone = shouldShowSwitchToPhone;
        self.shouldShowAudioVideoOptions = shouldShowAudioVideoOptions;
        self.shouldShowQandAAttendeeSubmit = shouldShowQandAAttendeeSubmit;
        self.shouldShowHandoutDownloads = shouldShowHandoutDownloads;
        self.showHandoutDownloads = showHandoutDownloads;
        self.sharedFilesCounter = 0;
        self.sharedFiles = [];

        // Custom Branding
        self.showCustomBranding = showCustomBranding;
        self.isCustomBrandingEnabled = attendeeService.getIsHost() && meetingService.hasFeature('branding');
        self.inMeetingLogo = '';

        self.showUBBranding = brandingService.getResellerCode() === 'univergeblue';

        self.virtualAssistantClick = virtualAssistantClick;
        self.shouldShowVirtualAssistant = shouldShowVirtualAssistant;

        // Polls
        self.polls_click = polls_click;
        self.polls_isVisible = polls_isVisible;

        self.toggleMobileChatAttendeeTabs = toggleMobileChatAttendeeTabs;

        //Reaction
        self.currentReaction = 'fine';
        self.isReactionMenuOpen = false;
        self.getCurrentReaction = getCurrentReaction;
        self.setReaction = setReaction;
        self.isReactionShown = isReactionShown;
        self.openReactionMenu = openReactionMenu;
        self.closeReactionMenu = closeReactionMenu;
        self.getScreenHeightAdjustment = getScreenHeightAdjustment;
        self.onGetSharedFilesData = onGetSharedFilesData;

        //Meeting Reactions
        self.isMeetingReactionShown = isMeetingReactionShown;

        // Feature List
        self.hasRecordingFeature = meetingService.hasFeature('recording');
        self.hasContentLibraryFeature = meetingService.hasFeature('slides');

        self.showConnectOverlay = false;
        self.fadeDuration = '0s';
        self.message = '';
        self.connectOverlayInitiated = false;

        //QA Mode
        self.toggleQAMode = toggleQAMode;
        self.canEnableQAMode = canEnableQAMode;

        self.togglePopover = togglePopover;

        //Mute State Notification
        self.hasShownDefaultMutingStateInfo = false;
        self.dismissDefaultMutingStateInfoTimer = null;
        self.setupDefaultMutedStateNotification = setupDefaultMutedStateNotification;
        self.showDefaultMutedStateNotification = showDefaultMutedStateNotification;
        self.hideDefaultMutedStateNotification = hideDefaultMutedStateNotification;
        self.shouldShowDefaultMutedStateNotification = shouldShowDefaultMutedStateNotification;
        self.applyDefaultMutedStateNotificationCloseHandler = applyDefaultMutedStateNotificationCloseHandler;
        self.setPopover = setPopover;

        //Phone Pair Notification
        self.hasShownPhonePairNotification = false;
        self.setupPhonePairNotification = setupPhonePairNotification;
        self.showPhonePairNotification = showPhonePairNotification;
        self.hidePhonePairNotification = hidePhonePairNotification;
        self.shouldShowPhonePairNotification = shouldShowPhonePairNotification;
        self.shouldShowPhonePairToast = shouldShowPhonePairToast;
        self.showPhonePairToast = showPhonePairToast;
        self.isPhonePairNotificationVisible = isPhonePairNotificationVisible;
        self.getAudioPin = getAudioPin;
        self.applyPhonePairNotificationCloseHandler = applyPhonePairNotificationCloseHandler;

        // All Webcams View Notification vars
        self.hasShownLGVNotification = false;
        self.dismissLGVTimer = null;

        var _hasLGVFeature;
        self.hasLGVFeature = hasLGVFeature;
        self.setupLGVNotification = setupLGVNotification;
        self.showLGVNotification = showLGVNotification;
        self.hideLGVNotification = hideLGVNotification;
        self.isLGVNotificationVisible = isLGVNotificationVisible;
        self.applyLGVNotificationCloseHandler = applyLGVNotificationCloseHandler;

        self.onLGVAvailable = onLGVAvailable;
        $scope.$on('lgv-available', self.onLGVAvailable);

        //Meeting Locked Notification
        self.hasShownMeetingLockedNotification = false;
        self.setupMeetingLockedNotification = setupMeetingLockedNotification;
        self.showMeetingLockedNotification = showMeetingLockedNotification;
        self.hideMeetingLockedNotification = hideMeetingLockedNotification;
        self.isMeetingLockedNotificationVisible = isMeetingLockedNotificationVisible;
        self.applyMeetingLockedNotificationCloseHandler = applyMeetingLockedNotificationCloseHandler;

        //Advanced Settings Notification
        self.shouldShowAdvancedSettingsNotification = shouldShowAdvancedSettingsNotification;
        self.advancedSettingsSize = 0;

        //This function determines what notification (security, beta, or security and beta) to show as meeting starts
        self.determineValuesForNotificationToShow = determineValuesForNotificationToShow;

        //setup,show, apply, and hide of popup for securityNotifications and Beta Notifications
        self.setupSecurityBetaSettingsNotification = setupSecurityBetaSettingsNotification;
        self.showSecurityBetaSettingsNotification = showSecurityBetaSettingsNotification;
        self.hideSecurityBetaSettingsNotification = hideSecurityBetaSettingsNotification;
        self.applySecurityBetaSettingsNotificationCloseHandler = applySecurityBetaSettingsNotificationCloseHandler;

        //Security Settings Notification
        self.hasShownSecuritySettingsNotification = false;
        self.isSecuritySettingsNotificationVisible = isSecuritySettingsNotificationVisible;
        self.dismissSecuritysettingsTimer = null;
        self.showJustSecuritySettingNotification = false;

        //BetaSettings
        self.hasShownBetaSettingsNotification = false;
        self.isBetaSettingsNotificationVisible = isBetaSettingsNotificationVisible;
        self.dismissBetaSettingsTimer = null;
        self.showJustBetaSettingNotification = false;

        //beta and security notification
        self.hasShownSecurityBetaSettingsNotification = false;
        self.isSecurityAndBetaSettingsNotificationVisible = isSecurityAndBetaSettingsNotificationVisible;
        self.dismissSecurityBetaSettingsTimer = null;

        //Current Talker
        self.shouldShowCurrentTalker = shouldShowCurrentTalker;
        self.getCurrentTalkerNames = getCurrentTalkerNames;

        //Mic Unplugged Notification
        self.micUnpluggedTextTitle = '';
        self.micUnpluggedTextBody = '';
        self.setupMicUnpluggedNotification = setupMicUnpluggedNotification;
        self.showMicUnpluggedNotification = showMicUnpluggedNotification;
        self.hideMicUnpluggedNotification = hideMicUnpluggedNotification;
        self.isMicUnpluggedNotificationVisible = isMicUnpluggedNotificationVisible;
        self.applyMicUnpluggedNotificationCloseHandler = applyMicUnpluggedNotificationCloseHandler;

        //Cam Unplugged Notification
        self.camUnpluggedTextTitle = '';
        self.camUnpluggedTextBody = '';
        self.setupCamUnpluggedNotification = setupCamUnpluggedNotification;
        self.showCamUnpluggedNotification = showCamUnpluggedNotification;
        self.hideCamUnpluggedNotification = hideCamUnpluggedNotification;
        self.isCamUnpluggedNotificationVisible = isCamUnpluggedNotificationVisible;
        self.applyCamUnpluggedNotificationCloseHandler = applyCamUnpluggedNotificationCloseHandler;

        // Mobile Audio Output
        self.getMobileAudioOutputDisplayClass = getMobileAudioOutputDisplayClass;
        self.getMobileAudioOutputTooltip = getMobileAudioOutputTooltip;
        self.toggleMobileSpeaker = toggleMobileSpeaker;
        self.setMobileAudioOutput = setMobileAudioOutput;
        self.hasMobileAudioOutputCapability = hasMobileAudioOutputCapability;
        self.checkCurrentMobileOutput = checkCurrentMobileOutput;
        self.checkAudioOutputToggleCapability = checkAudioOutputToggleCapability;
        self.isMobileSpeakerOn = true;
        self.isMobileSpeakerOnBeforeBackgrounding = false;

        self.onBackgroundModeActivated = onBackgroundModeActivated;
        self.onBackgroundModeDeactivated = onBackgroundModeDeactivated;

        self.getRecommendedTooltip = getRecommendedTooltip;

        self._initShouldShowScreenSharePermissionErrorStateValue = initShouldShowScreenSharePermissionErrorStateValue;

        // Help links
        self.webinarPresenterHelpLinks = [
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.AUDIO_AND_VIDEO_OPTIONS'),
                link: supportLinkService.getSupportLink('webinarAudioVideo')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.GREEN_ROOM'),
                link: supportLinkService.getSupportLink('webinarGreenRoom')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.POLLS'),
                link: supportLinkService.getSupportLink('webinarPolls')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.Q_AND_A'),
                link: supportLinkService.getSupportLink('webinarQA')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.SCREEN_SHARING'),
                link: supportLinkService.getSupportLink('webinarScreenSharing')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.SHARING_FILES_AND_VIDEOS'),
                link: supportLinkService.getSupportLink('webinarFileSharing')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.MANAGING_ATTENDEES'),
                link: supportLinkService.getSupportLink('webinarAttendees')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.GENERAL'),
                link: supportLinkService.getSupportLink('generic')
            }
        ];

        self.webinarAttendeeHelpLinks = [
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.HOW_DO_I'),
                link: supportLinkService.getSupportLink('generic')
            },
            {
                text: localizationService.translate('HEADER.WEBINAR_HELP.I_CANT_SEE_HEAR_ANYTHING'),
                link: supportLinkService.getSupportLink('webinarNoAudio')
            }
        ];

        self.handRaiseAvailable = handRaiseAvailable;
        self.onRaiseHandClick = onRaiseHandClick;

        self.hasToolbarMenu = hasToolbarMenu;
        self.hasRecordingIcon = hasRecordingIcon;
        self.hasVirtualAssistantIcon = hasVirtualAssistantIcon;
        self.hasSideToggle = hasSideToggle;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.getPoweredByName = meetingService.getPoweredByName;

        self.videoMutedBeforeBackgrounding = self.isVideoMuted;

        self.startEndMeetingRedirect = startEndMeetingRedirect;

        self.onConnectivityClick = onConnectivityClick;
        self.getStringForVideoShareState = getStringForVideoShareState;
        self.getStringForScreenShareState = getStringForScreenShareState;
        self.toggleShareVideo = toggleShareVideo;

        self.attachRedesignDropdownEventListeners = attachRedesignDropdownEventListeners;
        self.onDropdownToggled = onDropdownToggled;

        self.isPartnerUser = brandingService.isPartner();

        self.shouldShowFooter = shouldShowFooter;
        self.shouldShowSettings = shouldShowSettings;
        self.shouldShowSupport = shouldShowSupport;
        self.shouldShowEndMeeting = shouldShowEndMeeting;

        self.getIsPermissionAllowedForType = getIsPermissionAllowedForType;
        self.openMicCamPermissionTroubleShootPage = openMicCamPermissionTroubleShootPage;
        self.openCameraSystemPreference = openCameraSystemPreference;
        self.openMicrophoneSystemPreference = openMicrophoneSystemPreference;
        self.openMicCamPermissionTroubleShootPageForElectron = openMicCamPermissionTroubleShootPageForElectron;
        self.openScreenShareSystemPreference = openScreenShareSystemPreference;
        self.shouldShowScreenSharePermissionErrorState = shouldShowScreenSharePermissionErrorState;
        self.askedForScreenSharePermission = false;
        self.screenSharePermissionGranted = false;

        self.deviceHasError = deviceHasError;
        self.isAudioReconnectAllowed = isAudioReconnectAllowed;

        // Security settings
        self.isUnmutingSelfAllowed = isUnmutingSelfAllowed;
        self.isWebcamUnmutingSelfAllowed = isWebcamUnmutingSelfAllowed;
        self.isSharingScreenOrVideoAllowed = isSharingScreenOrVideoAllowed;

        //Layout Toggle Feature
        self.openLayoutToggleDropdown = openLayoutToggleDropdown;
        self.getToggleLayoutTooltip = getToggleLayoutTooltip;
        self.getGridviewLayoutToggleTooltip = getGridviewLayoutToggleTooltip;
        self.getLargeGalleryViewLayoutToggleTooltip = getLargeGalleryViewLayoutToggleTooltip;
        self.getSpotlightLayoutToggleTooltip = getSpotlightLayoutToggleTooltip;
        self.getCompactLayoutToggleTooltip = getCompactLayoutToggleTooltip;
        self.selectCompactModeLayout = selectCompactModeLayout;
        self.selectSpotlightLayout = selectSpotlightLayout;
        self.selectGalleryLayout = selectGalleryLayout;
        self.selectLargeGalleryLayout = selectLargeGalleryLayout;
        self.shouldShowToggleLayout = shouldShowToggleLayout;

        self.toggleShowAllWebcamVideos = toggleShowAllWebcamVideos;
        self.toggleShowSharedContent = toggleShowSharedContent;
        self.shouldShowSharedContentToggle = shouldShowSharedContentToggle;
        self.showAllWebcamVideos = true;
        self.showSharedContent = true;

        self.getBetaSettingContentText = getBetaSettingContentText;
        self.getBetaSettingTitleText = getBetaSettingTitleText;

        self.layoutLock = configService.isLayoutLockLocked();
        self.showLayoutLockNotification = showLayoutLockNotification;

        self.layoutControls = { enable: false, allhands: false };
        self.VDIRef = helperService.getVDIRef();
        self.updateTooltipPosition = !self.VDIRef.showContentsOnTopOfVideo;
        self.showAudioInputMicLevelIndicator = self.VDIRef.showAudioInputMicLevelIndicator;
        self.showTestAudioOutputOption = self.VDIRef.showTestAudioOutputOption;
        self.showMultipleVideoStreams = self.VDIRef.showMultipleVideoStreams;

        self.setupWebcamLimitLoweredNotification = setupWebcamLimitLoweredNotification;
        self.showWebcamLimitLoweredNotification = showWebcamLimitLoweredNotification;
        self.hideWebcamLimitLoweredNotification = hideWebcamLimitLoweredNotification;
        self.isWebcamLimitLoweredNotificationVisible = isWebcamLimitLoweredNotificationVisible;
        self.applyWebcamLimitLoweredNotificationCloseHandler = applyWebcamLimitLoweredNotificationCloseHandler;

        //Themed Features -- Designed for Direct/PLR (NOT UBMeet)
        self.hasThemedFeatures = hasThemedFeatures;
        self.toggleThemedFeatures = toggleThemedFeatures;
        self.getThemedFeaturesTooltip = getThemedFeaturesTooltip;
        self.isThemedFeaturesEnabled = isThemedFeaturesEnabled;
        self.getThemeType = getThemeType;
        self.getThemeIcons = getThemeIcons;
        self.getThemedReactions = getThemedReactions;

        self.loadedBugScript = false;

        // Compact Mode Feature
        self.isCompactMode = false;
        self.disableCompactModeBtn = disableCompactModeBtn;
        self.collapseCompactModeBtn = collapseCompactModeBtn;
        self.isCompactModeAvailable = meetingService.getCompactModeAvailable();
        self.getMinimizeToolTip = getMinimizeToolTip;
        self.getMaximizeToolTip = getMaximizeToolTip;

        self.shouldShowScreenSharePermissionErrorStateValue = false;
        self.getNodeConnectivityState = connectivityService.getNodeConnectivityState;

        self.hasRedesignFooter = true;

        // Toast Notification
        self.showToastNotification = false;
        self.toastNotificationMessage = '';
        self.toastDismiss = toastDismiss;

        self.isAudioDisconnected = isAudioDisconnected;
        self.toggleMuteAudioInputAndOutput = toggleMuteAudioInputAndOutput;
        self.showAudioDisconnectDialog = showAudioDisconnectDialog;
        self.getEnableAudioDisconnect = meetingService.getEnableAudioDisconnect;
        self.audioDisconnected = false;
        self.qualityData = {};
        self.shouldShowQualityBars = shouldShowQualityBars;
        self.shouldShowOldQualityIndicator = shouldShowOldQualityIndicator;
        self.getQualityIcon = getQualityIcon;
        // Oracle ODA Live Assistant
        self.openODACustomerSupport = openODACustomerSupport;
        self.getLiveAssistantTooltip = getLiveAssistantTooltip;
        self.shouldODALiveChat = shouldODALiveChat;
        self.updateODATotalAvailableAgents = updateODATotalAvailableAgents;
        self.onFsWsConnected = onFsWsConnected;

        self.isODAAgentsAvailable = false;

        self.modalsAvailable = false;
        self.rootSubscription = undefined;

        $scope.$on('toast-notification', onToastNotification);

        $scope.$on('meeting-end-redirect', onEndMeetingRedirect);
        $scope.$on('meeting-ending', onMeetingEnding);

        $scope.$on('update-local-audio-state', onUpdateLocalAudioState);
        $scope.$on('update-local-video-state', onUpdateLocalVideoState);
        $scope.$on('video-muted-updated', onUpdateLocalVideoState);
        $scope.$on('device-change-detected', onDeviceChangeDetected);
        $scope.$on('janus-local-media-stream-created', onJanusLocalMediaStreamCreated);

        $scope.$on('content-initiating', onContentInit);
        $scope.$on('content-init-cancelled', onContentInitCancelled);
        $scope.$on('content-playing', onContentPlaying);
        $scope.$on('content-stopped', onContentStopped);
        $scope.$on('content-status', onContentStatus);
        $scope.$on('sfu-screen-video-state', onSfuScreenVideoState);
        $scope.$on('phone-only-state', onPhoneOnlyState);
        $scope.$on('toggled-connect-overlay', onTogglingConnectOverlay);
        $scope.$on('attendee-partial', onAttendeePartial);
        $scope.$on('attendee-partial-property', onAttendeePartialProperty);
        $scope.$on('get-shared-files-data', onGetSharedFilesData);
        $scope.$on('shared-files-data-updated', onSharedFilesDataUpdated);
        $scope.$on('branding-info-updated', onBrandingInfoUpdated);
        $scope.$on('top-controls-onboarding-started', onTopControlsOnboardingStarted);
        $scope.$on('top-controls-onboarding-finished', onTopControlsOnboardingFinished);

        $scope.$on('e2ee-toggled', onE2EEToggled);
        $scope.$on('e2ee-state-updated', digest);
        $scope.$on('e2ee-enabled', onE2EEEnabled);

        $scope.$on('update-local-meeting-locked', onUpdateLocalMeetingLocked);
        $scope.$on('lock-meeting-allowed', onLockMeetingAllowed);
        $scope.$on('attendee-connectivity-state-changed', onAttendeeConnectivityStateChanged);
        $scope.$on('local-phone-pairing-state-updated', onLocalPhonePairingStateUpdated);
        $scope.$on('phone-state-updated', onPhoneStateUpdated);
        $scope.$on('bandwidth-state-changed', digest);
        $scope.$on('snapengage-agent-status', onSnapEngageAgentStatus);
        $scope.$on('show-mic-unplugged-notification', onShowMicUnpluggedNotification);
        $scope.$on('show-cam-unplugged-notification', onShowCamUnpluggedNotification);
        $scope.$on('verto-call-audio-input-updated', onVertoCallAudioInputUpdated);

        $scope.$on('sfu-screenshare-started', digest);
        $scope.$on('sfu-screenshare-stopped', digest);
        $scope.$on('janus-ice-state-updated', digest);
        $scope.$on('sfu-stopped-videos-on-loss', onStoppedVideosOnLoss);

        $scope.$on('mobile-headset-change-detected', onMobileHeadsetChangeDetected);

        $scope.$on('ipc-mute-cam', onIpcMuteCam);
        $scope.$on('ipc-unmute-cam', onIpcUnMuteCam);

        $scope.$on('ipc-mute-mic', onIpcMuteMic);
        $scope.$on('ipc-unmute-mic', onIpcUnMuteMic);

        $scope.$on('va-language-set', onVALanguageSet);

        $scope.$on('attendee-list-updated', digest);

        $scope.$on('advanced-settings-changed', onAdvancedSettingsChanged);

        $scope.$on('talking-while-muted-detected', onAttendeeTalkingWhileMuted);

        $scope.$on('audio-updated', onAttendeeAudioStatusChange);

        $scope.$on('virtual-background-stream-started', onVirtualBackgroundStreamStarted);

        $scope.$on('virtual-background-stream-error', onVirtualBackgroundStreamError);

        $scope.$on('leave-meeting-without-prompt', performLeaveMeeting);

        $scope.$on('videoroom-layout-controls', onLayoutChangeControls);

        $scope.$on('enable-video-on-reconnect', onEnableVideoOnReconnect);

        $scope.$on('screen-share-init-cancel', onScreenShareInitCancelled);

        $scope.$on('sfu-screenshare-presenter-started', onScreenSharePresenterStarted);

        $scope.$on('vdi-mute-video-on-device-change', onVDIMuteVideoOnDeviceChange);

        $scope.$on('vdi-toggle-preview-video-visibility', onVDITogglePreviewVideoVisibility);

        $scope.$on('oda-live-chat-total-available-agents', updateODATotalAvailableAgents);

        $scope.$on('sfu-sip-connected', onFsWsConnected);

        //TODO: Create named functions for the event callbacks below

        $scope.$on('recording-event', function (evt, args) {
            const isRecordingChanged = self.isRecording !== args.isRecording;
            self.isRecording = args.isRecording;

            if (!self.firstTimeRecording) {
                if (isRecordingChanged) {
                    var message = self.isRecording
                        ? localizationService.translate('RECORD.NOTIFICATION.RECORDING_STARTED')
                        : localizationService.translate('RECORD.NOTIFICATION.RECORDING_STOPPED');
                    notificationService.show(message, 'success');
                }
            } else {
                self.firstTimeRecording = false;
            }
            digest();
        });

        $scope.$on('max-video-limit-reached', function (event, data) {
            self.maxVideoFeedReached = true;

            var maxWebcams = data && data.maxWebcams;
            var exceededByAttendantId = data && data.exceededByAttendantId;

            if (maxWebcams) {
                self.maxVideoFeedReachedCount = maxWebcams;
            }

            if (exceededByAttendantId === self.attendantId) {
                notificationService.show(
                    localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.MAX_COUNT_OF_WEBCAMS_REACHED', {
                        count: self.maxVideoFeedReachedCount
                    }),
                    'warning'
                );
                if (data && data.hasScreenVideo) {
                    // stop screen video publish
                    if (self.hasMultishare && self.isScreenVideo) {
                        logService.log('stopping screen video because limit reached');
                        $rootScope.$broadcast('stop-sfu-screenshare');

                        $window.swal({
                            title: localizationService.translate(
                                'SCREENSHARE.DIALOG.THERE_IS_AN_ISSUE_SHARING_CONTENT'
                            ),
                            text: localizationService.translate(
                                'ATTENDEE_LIST.NOTIFICATIONS.MAX_COUNT_OF_WEBCAMS_REACHED',
                                {
                                    count: self.maxVideoFeedReachedCount
                                }
                            ),
                            confirmButtonColor: brandingService.getBaseColor(),
                            type: 'warning'
                        });
                    }
                } else {
                    $rootScope.$broadcast('stop-sfu-videopublish', true);
                }
            }

            digest();
        });

        $scope.$on('below-max-video-feed', function () {
            self.maxVideoFeedReached = false;

            digest();
        });

        //This event is left in for now just in case it triggers a UI digest
        $scope.$on('fs-connection-complete', self.onFSConnectionComplete);

        self.onForceVmute = onForceVmute;
        $scope.$on('force-vmute', self.onForceVmute);
        $scope.$on('enable-compact-mode', onCompactModeReceived);

        $scope.$on('self-quality-data-updated', qualityDataUpdated);
        $scope.$on('node-reconnected', onNodeReconnected);

        init();

        ////////////////////////

        function init() {
            preloadImages(
                '/img/redesign/icons/compact-mode-icons/mic-off-disabled.svg',
                '/img/redesign/icons/compact-mode-icons/mic-off-red.svg',
                '/img/redesign/icons/compact-mode-icons/mic-on-white.svg',
                '/img/redesign/icons/compact-mode-icons/phone-off-red.svg',
                '/img/redesign/icons/compact-mode-icons/phone-on-white.svg',
                '/img/redesign/icons/compact-mode-icons/phone-on-white.svg',
                '/img/redesign/icons/compact-mode-icons/reconnecting-spinner.gif',
                '/img/redesign/icons/compact-mode-icons/screenshare-blocked.svg',
                '/img/redesign/icons/compact-mode-icons/screenshare-off-white.svg',
                '/img/redesign/icons/compact-mode-icons/screenshare-on-white.svg',
                '/img/redesign/icons/compact-mode-icons/webcam-blocked.svg',
                '/img/redesign/icons/compact-mode-icons/webcam-off-disabled.svg',
                '/img/redesign/icons/compact-mode-icons/webcam-off-red.svg',
                '/img/redesign/icons/compact-mode-icons/webcam-off-white.svg'
            );
            getInitialWebCamMaxState();

            // Get Shared Files Data
            var msg = {
                message: 'get-shared-files-data',
                data: {},
                callback: self.onGetSharedFilesData
            };
            socketService.send(msg);

            if (helperService.isMobile()) {
                $window.cordova.plugins.backgroundMode.on('activate', self.onBackgroundModeActivated);
                $window.cordova.plugins.backgroundMode.on('deactivate', self.onBackgroundModeDeactivated);

                if (self.isIOS) {
                    $document.on('audioroute-changed', function (event) {
                        self.checkCurrentMobileOutput();
                    });
                }
            } else if (attendeeService.getIsHost() && !self.isWebinar()) {
                getLockMeetingAllowed();
            }

            self.attachDeviceDropdownEventListeners();

            if (helperService.getIsRedesign()) {
                self.attachRedesignDropdownEventListeners();
            }

            if (!self.VDIRef.showContentsOnTopOfVideo) {
                self.attachTooltipHideListeners();
            }

            var brandingInfo = meetingService.getBrandingInfo();
            if (brandingInfo && brandingInfo.inMeetingLogoURL) {
                self.inMeetingLogo = brandingInfo.inMeetingLogoURL;
                digest();
            }

            initShouldShowScreenSharePermissionErrorStateValue();

            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
        }

        function initShouldShowScreenSharePermissionErrorStateValue() {
            return shouldShowScreenSharePermissionErrorState().then(value => {
                logService.log('Got ShowScreenSharePermissionErrorState', value);
                if (value !== self.shouldShowScreenSharePermissionErrorStateValue) {
                    self.shouldShowScreenSharePermissionErrorStateValue = value;
                    digest();
                }
            });
        }

        function showLayoutLockNotification() {
            if (self.layoutLock && !attendeeService.getIsHost()) {
                notificationService.show(
                    localizationService.translate('HEADER.SETTINGS.HOST_LAYOUT_LOCK_ATTENDEE_TOOLTIP'),
                    'success'
                );
            }
        }

        function onAdvancedSettingsChanged(e, data) {
            self.layoutLock = configService.isLayoutLockLocked();
            if (self.layoutLock) {
                self.showLayoutLockNotification();
            }
        }

        function onBackgroundModeActivated() {
            logger.log('onBackgroundModeActivated', 'Is video muted:', self.isVideoMuted);

            self.videoMutedBeforeBackgrounding = self.isVideoMuted;
            if (!self.isVideoMuted) {
                self.toggleCamClick();
            }

            //Save state of audio output upon backgrounding
            self.isMobileSpeakerOnBeforeBackgrounding = self.isMobileSpeakerOn ? true : false;
        }

        function onBackgroundModeDeactivated() {
            logger.log('onBackgroundModeDeactivated', 'Is video muted:', self.isVideoMuted);

            if (self.videoMutedBeforeBackgrounding !== self.isVideoMuted) {
                self.toggleCamClick();
            }

            mobileAVDeviceService
                .checkCurrentMobileOutput()
                .then(function (data) {
                    //If mobile audio output is not in the same state as it was upon backgrounding, we set it back to the original state
                    if ((data && data.isMobileSpeakerOn) !== self.isMobileSpeakerOnBeforeBackgrounding) {
                        var newMobileAudioOutput = self.isMobileSpeakerOnBeforeBackgrounding
                            ? mobileAVDeviceService.audioOutputs.SPEAKER
                            : mobileAVDeviceService.audioOutputs.EARPIECE;
                        self.setMobileAudioOutput(newMobileAudioOutput);
                    }
                })
                .catch(function (e) {
                    logService.log('checkCurrentMobileOutput Error:', e);
                });
        }

        function onIpcMuteMic() {
            self.toggleMicClick();
        }

        function onIpcUnMuteMic() {
            self.toggleMicClick();
        }

        function onIpcMuteCam() {
            logger.log('onIpcMuteCam', 'mute webcam');

            self.toggleCamClick();
        }

        function onIpcUnMuteCam() {
            logger.log('onIpcUnMuteCam', 'unmute webcam');

            self.toggleCamClick();
        }

        function getInitialWebCamMaxState() {
            var msg = {
                message: 'max-video-feed-reached',
                data: {},
                callback: function (resp, max) {
                    if (max) {
                        self.maxVideoFeedReachedCount = max;
                    }

                    if (resp === true) {
                        self.maxVideoFeedReached = true;
                    }
                }
            };

            socketService.send(msg);
        }

        function usingTelephone() {
            return connectivityService.getAudioThroughPhone();
        }

        function getCameraTooltip() {
            if (!self.isAttendeeConnected()) {
                return self.getConnectingToDisplayText();
            }

            if (!self.hasWebRTC) {
                return localizationService.translate('HEADER.TOOLTIP.BROWSER_DOES_NOT_SUPPORT_FEATURE');
            }

            if (!self.hasCamera()) {
                return localizationService.translate('HEADER.TOOLTIP.NO_CAMERA_DETECTED');
            }

            var videoDeviceError = avDeviceService.getSfuDeviceErrorFromId(storageService.get('video-device'));

            if (!avDeviceService.getDevicePermissions().videoAllowed) {
                return localizationService.translate('HEADER.TOOLTIP.YOUR_CAMERA_IS_BLOCKED');
            }

            if (self.maxVideoFeedReached == true && self.isVideoMuted == true) {
                return localizationService.translate('HEADER.TOOLTIP.MAX_WEBCAMS_CAN_BE_DISPLAYED', {
                    videoFeedCount: self.maxVideoFeedReachedCount
                });
            }

            if (attendeeService.getIsWaitingForVideoUpdate()) {
                if (self.isVideoMuted) {
                    return localizationService.translate('HEADER.TOOLTIP.SHARING_YOUR_WEBCAM');
                } else {
                    return localizationService.translate('HEADER.TOOLTIP.STOPPING_YOUR_WEBCAM');
                }
            }

            if (self.isVideoMuted == false) {
                return localizationService.translate('HEADER.TOOLTIP.STOP_YOUR_WEBCAM');
            }

            // Check security setting
            if (!self.isWebcamUnmutingSelfAllowed()) {
                return localizationService.translate('HEADER.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE');
            }

            if (self.maxVideoFeedReached == false && self.isVideoMuted == true) {
                return localizationService.translate('HEADER.TOOLTIP.SHARE_YOUR_WEBCAM');
            }

            return '';
        }

        function getCameraDisplayClass() {
            var classes = [];

            // 'waiting-for-update'
            if (attendeeService.getIsWaitingForVideoUpdate()) {
                classes.push('waiting-for-update');
            }

            // 'disabled'
            if (
                !self.isWebcamUnmutingSelfAllowed() ||
                !self.hasWebRTC ||
                !self.hasCamera() ||
                !self.isConferenceConnected() ||
                (self.maxVideoFeedReached && self.isVideoMuted) ||
                !avDeviceService.getDevicePermissions().videoAllowed
            ) {
                classes.push('disabled');
            }

            // 'zmdi-videocam-off'
            if (self.isVideoMuted) {
                classes.push('zmdi-videocam-off');
            }

            // 'zmdi-videocam'
            if (!self.isVideoMuted) {
                classes.push('zmdi-videocam');

                // 'active'
                if (classes.indexOf('waiting-for-update') === -1 && classes.indexOf('disabled') === -1) {
                    classes.push('active');
                }
            }

            if (
                self.isConferenceConnected() &&
                meetingService.getCompactModeAvailableForRestyling() &&
                self.hasCamera()
            ) {
                classes.push('restyle');
            }

            return classes.join(' ');
        }

        function getMobileAudioOutputTooltip() {
            if (self.isMobileSpeakerOn) {
                return localizationService.translate('HEADER.WEBINAR.CHANGE_AUDIO_OUTPUT_TO_HEADSET');
            } else {
                return localizationService.translate('HEADER.WEBINAR.CHANGE_AUDIO_OUTPUT_TO_DEVICE_SPEAKER');
            }
        }

        function getMobileAudioOutputDisplayClass() {
            if (self.isMobileSpeakerOn) {
                return 'zmdi-volume-up active';
            } else {
                return 'zmdi-volume-up';
            }
        }

        function getConnectingToDisplayText() {
            var meetingType = meetingService.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_WEBINAR')
                : localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_MEETING');

            return localizationService.translate('HEADER.TOOLTIP.CONNECTING_TO', { meeting_type: meetingType });
        }

        function getMicrophoneToolTip() {
            if (!self.isAttendeeConnected()) {
                return self.getConnectingToDisplayText();
            }

            if (avDeviceService.isAudioDisconnected() && !connectivityService.getAudioThroughPhone()) {
                return localizationService.translate('HEADER.TOOLTIP.AUDIO_DISCONNECTED');
            }

            if (
                (connectivityService.getAudioThroughPhone() && !self.isTelephonePaired()) ||
                (!self.isWebinar() && !self.hasWebRTC)
            ) {
                return localizationService.translate('HEADER.TOOLTIP.SHOW_DIAL_IN_INFO');
            }

            if (!self.hasMicrophone() && !self.isTelephonePaired()) {
                return localizationService.translate('HEADER.TOOLTIP.MICROPHONE_DISCONNECTED');
            }

            var audioDeviceError = avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device'));

            if (!avDeviceService.getDevicePermissions().audioAllowed && !self.isTelephonePaired()) {
                return localizationService.translate('HEADER.TOOLTIP.MICROPHONE_BLOCKED');
            }

            if (attendeeService.getIsWaitingForAudioUpdate()) {
                return self.isAudioMuted
                    ? localizationService.translate('HEADER.TOOLTIP.UNMUTING_MIC')
                    : localizationService.translate('HEADER.TOOLTIP.MUTING_MIC');
            }

            if (self.isMicrophoneHavingAnIssue()) {
                return (
                    localizationService.translate('HEADER.TOOLTIP.MICROPHONE_DISCONNECTED') +
                    (avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device'))
                        ? '. ' + localizationService.translate('HEADER.TOOLTIP.CLICK_HERE_TO_RECONNECT')
                        : '')
                );
            }

            if (!self.isAudioMuted) {
                return self.isTelephonePaired()
                    ? localizationService.translate('HEADER.TOOLTIP.MUTE_PHONE')
                    : localizationService.translate('HEADER.TOOLTIP.MUTE_MIC');
            }

            // Check security setting
            if (!self.isUnmutingSelfAllowed()) {
                return localizationService.translate('HEADER.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE');
            }

            if (self.isTelephonePaired()) {
                return localizationService.translate('HEADER.TOOLTIP.UNMUTE_PHONE');
            }

            return localizationService.translate('HEADER.TOOLTIP.SHARE_MIC');
        }

        function isUnmutingSelfAllowed() {
            return meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio') !== false;
        }

        function isWebcamUnmutingSelfAllowed() {
            return meetingService.isAllowedByHostSecuritySettings('canUnmuteWebcam') !== false;
        }

        function isSharingScreenOrVideoAllowed() {
            return meetingService.isAllowedByHostSecuritySettings('canShareScreenOrVideo') !== false;
        }

        // Redesign
        function getScreenShareTooltip() {
            // Check security setting
            if (!self.isSharingScreenOrVideoAllowed()) {
                return localizationService.translate('HEADER.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE');
            } else if (!self.hasScreenShareOS) {
                return localizationService.translate('HEADER.TOOLTIP.OS_DOES_NOT_SUPPORT_FEATURE');
            } else if (!self.hasScreenShareBrowser) {
                return localizationService.translate('HEADER.TOOLTIP.BROWSER_DOES_NOT_SUPPORT_FEATURE');
            } else if (!self.isConferenceConnected()) {
                return self.getConnectingToDisplayText();
            } else if (self.shouldShowScreenSharePermissionErrorStateValue) {
                return localizationService.translate('HEADER.PERMISSIONS_ERROR.SCREENSHARE.INSTRUCTION_HEADER');
            } else if (self.isContentInitiating && !self.isContentOwner) {
                return localizationService.translate('HEADER.TOOLTIP.ATTENDEE_IS_PREPARAING_TO_SHARE_CONTENT');
            } else if (self.isContentInitiating && self.isContentOwner) {
                return localizationService.translate('HEADER.TOOLTIP.YOU_ARE_PREPARING_TO_SHARE_CONTENT');
            } else if ((self.isScreenShareConnected && self.isContentOwner) || self.isScreenVideo) {
                if (self.isFilePlay) {
                    return localizationService.translate('HEADER.TOOLTIP.END_YOUR_CURRENT_VIDEO_PLAY_SESSION');
                } else {
                    return localizationService.translate('HEADER.TOOLTIP.END_YOUR_CURRENT_SCREENSHARE_SESSION');
                }
            } else if (
                self.getHasMultishare() &&
                !!contentService.isContentPlaying() &&
                self.attendantId !== contentService.getContentOwner() &&
                !contentService.getIsFilePlay()
            ) {
                return localizationService.translate('HEADER.TOOLTIP.SHARE_YOUR_SCREEN');
            } else if (!!contentService.isContentPlaying() && self.attendantId !== contentService.getContentOwner()) {
                return localizationService.translate('HEADER.TOOLTIP.SHARE_TO_INTERRUPT_CONTENT');
            } else {
                return localizationService.translate('HEADER.TOOLTIP.SHARE_YOUR_SCREEN');
            }
        }

        function getHasMultishare() {
            // disable multishare if recording is enabled and multishareRecord is default null.
            if (self.hasMultishare) {
                return !!self.multishareRecord || !self.isRecording;
            }
            return false;
        }

        // Redesign
        function getScreenShareOptionsTooltip() {
            // Check security setting
            if (!self.isSharingScreenOrVideoAllowed()) {
                return '';
            }

            return localizationService.translate('HEADER.TOOLTIP.VIEW_SCREENSHARE_OPTIONS');
        }

        // Non-redesign
        function getshareContentToolTip() {
            if (!self.hasWebRTC) {
                return localizationService.translate('HEADER.TOOLTIP.BROWSER_DOES_NOT_SUPPORT_FEATURE');
            } else {
                if (!self.hasContentLibraryFeature) {
                    if (brandingService.isAnymeetingDirect()) {
                        if (attendeeService.getIsHost() == true) {
                            return localizationService.translate(
                                'RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE'
                            );
                        } else {
                            return localizationService.translate(
                                'RECORD.TOOLTIP.MEETING_HOST_PLAN_DOES_NOT_INCLUDE_FEATURE'
                            );
                        }
                    } else {
                        if (attendeeService.getIsHost() == true) {
                            return localizationService.translate(
                                'RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE_CONTACT_ADMIN'
                            );
                        } else {
                            return localizationService.translate(
                                'RECORD.TOOLTIP.MEETING_HOST_PLAN_DOES_NOT_INCLUDE_FEATURE'
                            );
                        }
                    }
                } else {
                    if (!self.isConferenceConnected()) {
                        return localizationService.translate('HEADER.DIALOG.SHARE_MIC_AND_WEBCAM');
                    } else {
                        return localizationService.translate('HEADER.WEBINAR.SHARE_FILES_AND_VIDEOS');
                    }
                }
            }
        }

        function getToggleRecordingToolTip() {
            if (self.hasRecordingFeature) {
                if (self.isRecordingEnabled()) {
                    if (self.isRecording) {
                        return localizationService.translate('RECORD.TOOLTIP.MEETING_IS_BEING_RECORDER');
                    } else {
                        return localizationService.translate('RECORD.TOOLTIP.RECORD_YOUR_MEETING');
                    }
                } else {
                    if (meetingService.e2eeEnabled()) {
                        return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_RECORDING_DISABLED');
                    } else {
                        return localizationService.translate(
                            'RECORD.TOOLTIP.MEETING_IS_BEING_RECORDER_ONLY_HOST_CAN_START_RECORD'
                        );
                    }
                }
            } else {
                if (brandingService.isAnymeetingDirect()) {
                    if (attendeeService.getIsHost()) {
                        return localizationService.translate('RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE');
                    } else {
                        return localizationService.translate(
                            'RECORD.TOOLTIP.MEETING_HOST_PLAN_DOES_NOT_INCLUDE_FEATURE'
                        );
                    }
                } else {
                    if (attendeeService.getIsHost()) {
                        return localizationService.translate(
                            'RECORD.TOOLTIP.YOUR_PLAN_DOERS_NOT_INCLUDE_THIS_FEATURE_CONTACT_ADMIN'
                        );
                    } else {
                        return localizationService.translate(
                            'RECORD.TOOLTIP.MEETING_HOST_PLAN_DOES_NOT_INCLUDE_FEATURE'
                        );
                    }
                }
            }
        }

        function getVirtualAssistantTooltip() {
            if (meetingService.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_VIRTUAL_ASSISTANT_DISABLED');
            }

            if (self.transcriptionActive()) {
                return localizationService.translate('HEADER.TOOLTIP.VIRTUAL_ASSISTANT_ACTIVE');
            } else {
                return localizationService.translate('HEADER.TOOLTIP.VIRTUAL_ASSISTANT_ADD');
            }
        }

        function showSwitchToMic() {
            return self.usingTelephone() && self.hasMicrophone();
        }

        function showDialInInfo() {
            $rootScope.$broadcast('show-modal', 'dialInInformation');
        }

        function getMicrophoneDisplayClass() {
            var classes = [];

            // 'waiting-for-update'
            if (attendeeService.getIsWaitingForAudioUpdate()) {
                classes.push('waiting-for-update');
            }

            // 'zmdi-mic-off'
            if (!self.isTelephonePaired() && !self.usingTelephone() && self.isAudioMuted) {
                classes.push('zmdi-mic-off');
            }

            // 'zmdi-mic'
            if (!self.isTelephonePaired() && !self.usingTelephone() && !self.isAudioMuted && self.hasWebRTC) {
                classes.push('zmdi-mic');

                // 'active'
                if (
                    avDeviceService.getDevicePermissions().audioAllowed &&
                    !attendeeService.getIsWaitingForAudioUpdate()
                ) {
                    classes.push('active');
                }
            }

            // 'zmdi-phone custom-icon'
            if ((self.usingTelephone() && !self.isTelephonePaired()) || (!self.isWebinar() && !self.hasWebRTC)) {
                classes.push('zmdi-phone custom-icon');
            }

            // 'zmdi-phone custom-icon'
            if (self.isTelephonePaired()) {
                classes.push('zmdi-phone custom-icon');

                // 'phone-disabled'
                if (self.isAudioMuted) {
                    classes.push('phone-disabled');

                    // 'active'
                } else if (!attendeeService.getIsWaitingForAudioUpdate()) {
                    classes.push('active');
                }
            }

            // Check security setting
            if (!self.isUnmutingSelfAllowed()) {
                classes.push('disabled');
            } else if (self.hasWebRTC) {
                // 'disabled'
                if (!self.isConferenceConnected()) {
                    classes.push('disabled');
                } else if (!self.usingTelephone()) {
                    // 'disabled'
                    if (
                        !self.hasMicrophone() ||
                        !avDeviceService.getDevicePermissions().audioAllowed ||
                        self.isMicrophoneHavingAnIssue()
                    ) {
                        classes.push('disabled');
                    }
                }
            }

            var disabledIndex = classes.indexOf('disabled');
            var activeIndex = classes.indexOf('active');

            // Prevent 'active' and 'disabled' classes from being applied together
            if (disabledIndex > -1 && activeIndex > -1) {
                classes.splice(activeIndex, 1);
            }

            return classes.join(' ');
        }

        // Used for Redesign
        function getMicrophoneDisplaySrc() {
            let filename = 'mic-on-blue.svg';
            let folder = 'footer_icons/';

            if (self.isCompactMode || meetingService.getCompactModeAvailableForRestyling() || self.hasRedesignFooter) {
                filename = 'mic-on-white.svg';
                folder = 'compact-mode-icons/';
            }

            if (self.usingTelephone()) {
                if (
                    self.isCompactMode ||
                    meetingService.getCompactModeAvailableForRestyling() ||
                    self.hasRedesignFooter
                ) {
                    if (
                        !connectivityService.getConferenceConnected() ||
                        (self.isTelephonePaired() && self.isAudioMuted)
                    ) {
                        filename = 'phone-off-red.svg';
                    } else {
                        filename = 'phone-on-white.svg';
                    }
                } else {
                    if (
                        !connectivityService.getConferenceConnected() ||
                        (self.isTelephonePaired() && self.isAudioMuted)
                    ) {
                        filename = 'phone-off.svg';
                    } else {
                        filename = 'phone-on-blue.svg';
                    }
                }
            } else {
                if (
                    self.isCompactMode ||
                    meetingService.getCompactModeAvailableForRestyling() ||
                    self.hasRedesignFooter
                ) {
                    if (
                        !self.isUnmutingSelfAllowed() ||
                        !self.getIsPermissionAllowedForType('audio') ||
                        !self.isMicUsable()
                    ) {
                        filename = 'mic-off-disabled.svg';
                    } else if (self.isAudioMuted && connectivityService.getConferenceConnected()) {
                        filename = 'mic-off-red.svg';
                    }
                } else {
                    if (!self.isUnmutingSelfAllowed() || !self.getIsPermissionAllowedForType('audio')) {
                        filename = 'mic-off-disabled.svg';
                    } else if (self.isAudioMuted || !self.isMicUsable()) {
                        filename = 'mic-off.svg';
                    }
                }
            }

            return '/img/redesign/icons/' + folder + filename;
        }

        // Used for Redesign
        function isMicUsable() {
            if (
                self.hasMicrophone() &&
                avDeviceService.getDevicePermissions().audioAllowed &&
                !self.isMicrophoneHavingAnIssue() &&
                connectivityService.getConferenceConnected()
            ) {
                return true;
            } else {
                return false;
            }
        }

        function hasMicrophone() {
            return avDeviceService.hasMicrophone();
        }

        function hasCamera() {
            return avDeviceService.hasCamera();
        }

        function more_switchToMic_click() {
            logService.log('Header - Switch-to-Mic button clicked - Showing confirmation prompt');
            self.hideVideosInMeetingVDI();

            var switchToMicCloseButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            $window.swal(
                {
                    title:
                        switchToMicCloseButtonHtml +
                        '<div class="sweetalert-text-fix-size">' +
                        localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE_QUESTION') +
                        '</div>',
                    text: '',
                    showCancelButton: true,
                    confirmButtonColor: brandingService.getBaseColor(),
                    cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                    confirmButtonText: localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE'),
                    closeOnConfirm: true,
                    html: true,
                    imageUrl: 'img/redesign/modal/pop-up-pic-switch-to-mcr.svg',
                    customClass: 'switch-to-mic-modal auto-size'
                },
                function (switchToMic) {
                    if (switchToMic) {
                        logService.log('Header - Confirmed switch-to-mic');
                        connectivityService.setAudioThroughPhone(false, true);
                        self.hidePhonePairNotification();
                        self.showVideosInMeetingVDI();
                    } else {
                        logService.log('Header - Cancelled switch-to-mic');
                        self.showVideosInMeetingVDI();
                    }
                }
            );
        }

        function more_switchToPhone_click() {
            if (self.e2eeEnabled()) {
                return;
            }

            logService.log('Header - Switch-to-Phone button clicked - Showing confirmation prompt');
            if (self.isAudioDisconnected()) {
                analyticsWrapperService.eventTrack('Meeting - Switch from no audio to phone audio', {
                    category: 'Header menu'
                });
            }

            self.hideVideosInMeetingVDI();
            var switchToPhoneCloseButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';

            var swalOptsSwitchToPhone = {
                title:
                    switchToPhoneCloseButtonHtml +
                    '<div class="sweetalert-text-fix-size">' +
                    localizationService.translate('HEADER.DIALOG.SWITCH_TO_PHONE') +
                    '</div>',
                text: '',
                showCancelButton: true,
                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                confirmButtonText: localizationService.translate('HEADER.DIALOG.YES_SWITCH_TO_PHONE'),
                closeOnConfirm: true,
                html: true,
                imageUrl: 'img/redesign/modal/pop-up-pic-switch-to-phn.svg',
                customClass: 'switch-to-mic-modal auto-size'
            };

            $window.swal(swalOptsSwitchToPhone, function (switchToPhone) {
                if (switchToPhone) {
                    logService.log('Header - Confirmed switch-to-phone');
                    if (avDeviceService.isAudioDisconnected()) {
                        avDeviceService.toggleMuteAudioInputAndOutput();
                    }
                    $rootScope.$broadcast('stop-tracking-local-audio');
                    self.hideTalkingWhileMutedNotification();
                    connectivityService.setAudioThroughPhone(true, true);
                    self.showVideosInMeetingVDI();
                } else {
                    logService.log('Header - Cancelled switch-to-phone');
                    self.showVideosInMeetingVDI();
                }
            });
        }

        function showAudioDisconnectDialog() {
            logService.log('Header - Switch-to-Phone button clicked - Showing confirmation prompt');

            self.hideVideosInMeetingVDI();
            var switchToPhoneCloseButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';

            var swalOptsSwitchToPhone = {
                title:
                    switchToPhoneCloseButtonHtml +
                    '<div class="sweetalert-text-fix-size">' +
                    (avDeviceService.isAudioDisconnected()
                        ? localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE_QUESTION')
                        : localizationService.translate('HEADER.DIALOG.DISCONNECT_AUDIO_PROMPT')) +
                    '</div>',
                text: '',
                showCancelButton: true,
                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                confirmButtonText: avDeviceService.isAudioDisconnected()
                    ? localizationService.translate('HEADER.DIALOG.SWITCH_TO_MICROPHONE')
                    : localizationService.translate('HEADER.DIALOG.DISCONNECT_AUDIO'),
                closeOnConfirm: true,
                html: true,
                imageUrl: avDeviceService.isAudioDisconnected()
                    ? 'img/redesign/modal/pop-up-pic-switch-to-mcr.svg'
                    : 'img/redesign/modal/pop-up-pic-disconnect-audio.svg',
                customClass: 'switch-to-mic-modal auto-size'
            };

            $window.swal(swalOptsSwitchToPhone, function (disconnectAudio) {
                if (disconnectAudio) {
                    logService.log('Header - Confirmed disconnect audio');
                    if (connectivityService.getAudioThroughPhone()) {
                        connectivityService.setAudioThroughPhone(false, true);
                        self.hidePhonePairNotification();
                    }
                    $rootScope.$broadcast('stop-tracking-local-audio');
                    self.hideTalkingWhileMutedNotification();
                    avDeviceService.toggleMuteAudioInputAndOutput(true);
                    self.showVideosInMeetingVDI();
                } else {
                    logService.log('Header - Cancelled disconnect audio');
                    self.showVideosInMeetingVDI();
                }
            });
        }

        function more_audioVideoOption_click() {
            logService.log('more_audioVideoOption_click');
            self.openAVSettings();
        }

        function more_webinarOptions_click() {
            logService.log('more_webinarOptions_click');
            $rootScope.$broadcast('show-modal', 'webinarOptions');
        }

        function getConnectivityIconState() {
            var connectivityObj = {
                packetLoss: {
                    state: connectivityService.getPacketLossState()
                },
                bandwidth: {
                    up: vertoService.getAttendeeUploadBandwidth(),
                    down: vertoService.getAttendeeDownloadBandwidth()
                }
            };

            return connectivityService.getConnectivityIconState(connectivityObj);
        }

        function toggleMicClick(event) {
            // Check security setting
            if (self.isUnmutingSelfAllowed() === false) {
                return;
            }

            if (attendeeService.getIsWaitingForAudioUpdate()) {
                return;
            }

            if (avDeviceService.isAudioDisconnected() && !connectivityService.getAudioThroughPhone()) {
                return;
            }

            const devicePermissions = avDeviceService.getDevicePermissions();

            if (!devicePermissions.audioAllowed) {
                // audio was not allowed, probably not enough permissions, so check permissions granted
                avDeviceService
                    .checkIfAVDevicePermissionsGranted()
                    .then(function () {
                        self.toggleMicInternal(event);
                    })
                    .catch(function (err) {
                        logger.log('toggleMicClick', 'Unable to check if AV Device permissions granted', err);
                        avDeviceService.startWebrtcPromptOverlay();
                    });
            } else {
                self.toggleMicInternal(event);
            }
        }

        function toggleMicInternal(event) {
            const devicePermissions = avDeviceService.getDevicePermissions();

            if (!devicePermissions.audioAllowed && self.hasMicrophone() && event) {
                event.stopPropagation();
                self.toggleDeviceDropdown({ currentTarget: $('#audio-device-dropdown .dropdown-toggler') }, 'audio');
                return;
            }

            var webAttendeeWithActiveMic =
                self.hasWebRTC &&
                self.hasMicrophone() &&
                !connectivityService.getAudioThroughPhone() &&
                devicePermissions.audioAllowed &&
                !self.isMicrophoneHavingAnIssue();
            var phonePairedAttendee = self.isTelephonePaired();

            if (connectivityService.getConferenceConnected() && (webAttendeeWithActiveMic || phonePairedAttendee)) {
                if (self.isAudioMuted) {
                    analyticsWrapperService.eventTrack('Meeting - Talk Unmute', {
                        category: 'Header menu'
                    });
                } else {
                    analyticsWrapperService.eventTrack('Meeting - Talk Mute', {
                        category: 'Header menu'
                    });
                }
                self.toggleAudio();
            } else if (
                (connectivityService.getConferenceConnected() && connectivityService.getAudioThroughPhone()) ||
                (!self.isWebinar() && !self.hasWebRTC)
            ) {
                $rootScope.$broadcast('show-modal', 'dialInInformation');
            } else if (
                connectivityService.getConferenceConnected() &&
                avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device')) &&
                avDeviceService.hasMicrophone()
            ) {
                if (meetingService.getIsSfuEnabled()) {
                    //If currently selected mic has device error, re-attempt audio sip call
                    $rootScope.$broadcast('reconnect-audio-input');
                }
            }
        }

        function toggleCamClick(event) {
            // Check security setting
            if (self.isWebcamUnmutingSelfAllowed() === false) {
                logger.warn(
                    'toggleCamClick',
                    'Can not toggle video',
                    'Host disabled webcam unmuting in the meeting settings.'
                );
                return;
            }

            if (self.isDeviceDropdownOpen('video')) {
                logger.warn('toggleCamClick', 'Can not toggle video', 'Video device dropdown open.');
                return;
            }

            if (!connectivityService.getConferenceConnected()) {
                logger.warn('toggleCamClick', 'Can not toggle video', 'Conference is not connected.');
                return;
            }

            if (meetingService.getIsSfuEnabled() && !connectivityService.getJanusWSConnected()) {
                logger.warn('toggleCamClick', 'Can not toggle video', 'Janus is not connected.');
                return;
            }

            if (attendeeService.getIsWaitingForVideoUpdate()) {
                logger.warn('toggleCamClick', 'Can not toggle video', 'Is waiting for video update.');
                return;
            }

            if (self.maxVideoFeedReached && self.isVideoMuted) {
                logger.warn('toggleCamClick', 'Can not toggle video', 'Max video feed reached.');
                return;
            }

            if (!avDeviceService.getDevicePermissions().videoAllowed) {
                // video was not allowed, probably not enough permissions, so check permissions granted
                avDeviceService
                    .checkIfAVDevicePermissionsGranted()
                    .then(function () {
                        self.toggleCamInternal(event);
                    })
                    .catch(function (err) {
                        logger.log('toggleCamClick', 'Unable to check if AV Device permissions granted', err);
                        avDeviceService.startWebrtcPromptOverlay();
                    });
            } else {
                self.toggleCamInternal(event);
            }
        }

        function toggleCamInternal(event) {
            const devicePermissions = avDeviceService.getDevicePermissions();
            const hasCamera = self.hasCamera();

            if (!devicePermissions.videoAllowed && hasCamera && event) {
                logger.warn('toggleCamInternal', `Toggle video: hasCamera=${hasCamera}`, devicePermissions);
                event.stopPropagation();
                self.toggleDeviceDropdown({ currentTarget: $('#audio-device-dropdown .dropdown-toggler') }, 'audio');
                return;
            }

            logger.log(
                'toggleCamInternal',
                `Toggle video: hasWebRTC=${self.hasWebRTC}; hasCamera=${hasCamera}`,
                devicePermissions
            );

            if (self.hasWebRTC && hasCamera && devicePermissions.videoAllowed) {
                if (self.isVideoMuted) {
                    analyticsWrapperService.eventTrack('Meeting - Cam vUnmute', {
                        category: 'Header menu'
                    });
                } else {
                    analyticsWrapperService.eventTrack('Meeting - Cam vMute', {
                        category: 'Header menu'
                    });
                }

                self.toggleVideo();
            }
        }

        function shouldShowToggleMore() {
            if (!meetingService.isWebinar()) {
                if (self.isMobile || self.phoneOnlyState) {
                    return false;
                }
                return true;
            } else if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    return true;
                }
                return false;
            }
        }

        function shouldShowSwitchToPhone() {
            var showSwitchToPhone = !self.usingTelephone() && self.hasWebRTC;

            if (helperService.getIsRedesign()) {
                return showSwitchToPhone;
            }

            return self.isConferenceConnected() && showSwitchToPhone;
        }

        function shouldShowAudioVideoOptions() {
            if (self.isConferenceConnected()) {
                return self.hasWebRTC || (!self.hasWebRTC && self.isWebinarAttendee());
            }
            return false;
        }

        function shouldShowQandAAttendeeSubmit() {
            return meetingService.isWebinar() && attendeeService.getIsAttendee();
        }

        function shouldShowHandoutDownloads() {
            return (
                !self.isMobile &&
                meetingService.isWebinar() &&
                attendeeService.getIsAttendee() &&
                config.webinar.handout &&
                self.sharedFiles.length > 0
            );
        }

        function showHandoutDownloads() {
            // Nullify Notification counter
            self.sharedFilesCounter = 0;
            $rootScope.$broadcast('show-modal', 'handoutDownloads');
        }

        function shouldShowShareDesktop() {
            if (!meetingService.isWebinar()) {
                if (self.isMobile || self.phoneOnlyState) {
                    return false;
                }
                return true;
            } else if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    return true;
                }
                return false;
            }
        }

        function shouldShowFooter() {
            return !helperService.isVideoRoomApplication();
        }

        function shouldShowSettings() {
            return !helperService.isVideoRoomApplication();
        }

        function shouldShowSupport() {
            return !helperService.isVideoRoomApplication();
        }

        function shouldShowEndMeeting() {
            return !helperService.isVideoRoomApplication();
        }

        function shouldShowToggleLayout() {
            return !helperService.isVideoRoomApplication();
        }

        function shouldHideCameraIcon() {
            return self.phoneOnlyState || (self.isMobile && self.isWebinar()) || self.isWebinarAttendee();
        }

        function shouldShowShareContent() {
            if (!meetingService.isWebinar()) {
                if (self.isMobile || self.phoneOnlyState) {
                    return false;
                }
                return true;
            } else if (meetingService.isWebinar()) {
                if (attendeeService.getIsPresenter()) {
                    return true;
                }
                return false;
            }
        }

        function showContentLibrary() {
            if (self.hasWebRTC) {
                $rootScope.$broadcast('show-modal', 'contentLibrary');
            }
        }

        function initiateLocalFileShare() {
            if (self.hasWebRTC && meetingService.getIsSfuEnabled()) {
                $rootScope.$broadcast('start-local-file-share');
            }
        }

        function getShareVideoTooltip() {
            if (self.e2eeEnabled()) {
                return localizationService.translate('SECURITY_SETTINGS.TOOLTIP.E2EE_VIDEO_SHARING_DISABLED');
            } else {
                return '';
            }
        }

        function toggleShareVideo() {
            // video sharing is not available in e2ee meeting
            if (self.e2eeEnabled()) {
                return;
            }

            if (!contentService.isContentPlaying()) {
                //No content playing, allow sharing video
                if (meetingService.getIsSfuEnabled()) {
                    self.initiateLocalFileShare();
                }

                logService.log('share video button clicked from Header - Starting Video');
            } else {
                if (contentService.getContentOwner() !== self.attendantId) {
                    //If you are not the owner, show override prompt
                    contentService.promptUserOverride('sfu-video');
                    logService.log(
                        "share video button clicked from Header - Calling promptUserOverride to override another user's content"
                    );
                } else if (self.isScreenShareConnected && !contentService.getIsFilePlay()) {
                    //If you are the owner, but the current content is not screenshare, show override prompt
                    contentService.promptUserOverride('sfu-video');
                    logService.log(
                        "share video button clicked from Header - Calling promptUserOverride to override user's own content"
                    );
                } else {
                    //If you are the owner, and the current content is screenshare, stop current content
                    contentService.stopCurrentContent();
                    logService.log('share video button clicked from Header - Calling stopCurrentContent');
                }
            }
        }

        function shouldShowVirtualAssistant() {
            return !meetingService.isWebinar() && meetingService.hasTranscriptionEnabled();
        }

        function virtualAssistantClick() {
            $rootScope.$broadcast('show-modal', 'virtualAssistantMessage');
        }

        function showCustomBranding() {
            logService.log('in show custom branding');
            $rootScope.$broadcast('show-modal', 'customBranding');
        }

        function polls_click() {
            $rootScope.$broadcast('show-modal', 'polls');
        }

        function startDiagnosticProcess() {
            analyticsWrapperService.eventTrack('Meeting - Feedback', {
                category: 'Header menu'
            });
            $rootScope.$broadcast('show-modal', 'meetingSurvey', true);
        }

        function reportAudioVideoQuality() {
            analyticsWrapperService.eventTrack('Meeting - Callstats Feedback', {
                category: 'Header menu'
            });
            $rootScope.$broadcast('show-modal', 'callstatsQualityFeedback');
        }

        function openCustomerSupport() {
            customerSupportService.openCustomerSupport();
        }

        function shouldShowCustomerSupportLiveChat() {
            return customerSupportService.canLoadSnapEngage();
        }

        function toggleFeatureFlags() {
            if (self.sfuEnabled) {
                $rootScope.$broadcast('showhide-feature-flags');
            }
        }

        function openAppCuesTutorial() {
            onboardingService.showTutorial();
        }

        function openWebinarsTutorial() {
            onboardingService.showWebinarsTutorial();
        }

        function openOurSupportSite(link) {
            if (link) {
                meetingService.openExternalLink(link);
            } else {
                //meetingService.openExternalLink(config.support.url);
                meetingService.openExternalLink(supportLinkService.getSupportLink('generic'));
            }
        }

        function onEndMeetingRedirect(e, url) {
            // if (
            //     attendeeService.shouldUseCallstatSurvey() &&
            //     !attendeeService.getCompletedCallstatSurvey() &&
            //     attendeeService.getIsHost() == false
            // ) {
            //     meetingService.setPreventRerouting(true);
            //     var callStatCallback = function () {
            //         self.startEndMeetingRedirect(url);
            //     };
            //     $rootScope.$broadcast('show-modal', 'callstatsQualityFeedback', callStatCallback);
            // } else {
            //     if (!attendeeService.getIsHost()) {
            //         self.startEndMeetingRedirect(url);
            //     }
            // }
            if (!attendeeService.getIsHost()) {
                self.startEndMeetingRedirect(url);
            }
        }

        function startEndMeetingRedirect(url) {
            if (!attendeeService.getIsHost()) {
                if (url.toLowerCase().indexOf('http://') !== 0 && url.toLowerCase().indexOf('https://') !== 0) {
                    meetingService.redirectAfterMeeting('http://' + url);
                } else {
                    meetingService.redirectAfterMeeting(url);
                }
            }
        }

        function endMeeting() {
            logService.log('calling headerCtrl.endMeeting ...');
            var msgObj = {
                message: 'end-meeting',
                data: {}
            };

            socketService.send(msgObj);

            analyticsWrapperService.submitMeetingDuration();
        }

        //This even can be trigged when leaving, when meeting ending, or when kicked
        function onMeetingEnding() {
            self.clearDeviceList();

            //Clean up any potential growl messages left open
            if ($window.$.growl) {
                $window.$.growl(false, { command: 'closeAll' });
            }

            self.toastDismiss();

            // Destroys ODA SDK instances and connections when meeting ends
            customerSupportService.ODACleanUp();
        }

        function toggleMobileSpeaker() {
            self.checkAudioOutputToggleCapability()
                .then(function (data) {
                    if (data && data.shouldToggle) {
                        var newMobileAudioOutput = self.isMobileSpeakerOn
                            ? mobileAVDeviceService.audioOutputs.EARPIECE
                            : mobileAVDeviceService.audioOutputs.SPEAKER;
                        var notificationText =
                            'Your speaker is ' +
                            (newMobileAudioOutput == mobileAVDeviceService.audioOutputs.SPEAKER ? 'on' : 'off');
                        notificationService.show(notificationText, 'success');
                        self.setMobileAudioOutput(newMobileAudioOutput);
                    } else {
                        logService.log('Not toggling audio output');
                    }
                })
                .catch(function (err) {
                    logService.log('Error checking audio output capability:', err);
                });
        }

        function checkAudioOutputToggleCapability() {
            var deferred = $q.defer();

            //Android needs additional logic to prevent switching to "earpiece" when it doesn't exist (i.e. for tablets)
            if (helperService.getDevicePlatform() === 'Android' && mobileAVDeviceService.hasBuiltInEarpiece === false) {
                mobileAVDeviceService
                    .checkForConnectedHeadset()
                    .then(function (hasConnectedHeadset) {
                        //If headset connected, we can continue to toggle mobile speaker
                        //Otherwise, we leave the audio output the same
                        deferred.resolve({ shouldToggle: hasConnectedHeadset ? true : false });
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
            } else {
                deferred.resolve({ shouldToggle: true });
            }

            return deferred.promise;
        }

        function setMobileAudioOutput(newMobileAudioOutput) {
            mobileAVDeviceService
                .setMobileAudioOutput(newMobileAudioOutput)
                .then(function () {
                    //Update local ctrl property 'isMobileSpeakerOn'
                    self.checkCurrentMobileOutput();
                })
                .catch(function (e) {
                    logService.log('setMobileAudioOutput Error:', e);
                });
        }

        function hasMobileAudioOutputCapability() {
            if (helperService.isMobile()) {
                var devicePlatform = helperService.getDevicePlatform();
                return devicePlatform === 'iOS' || devicePlatform === 'Android';
            }

            return false;
        }

        function checkCurrentMobileOutput() {
            mobileAVDeviceService
                .checkCurrentMobileOutput()
                .then(function (data) {
                    self.isMobileSpeakerOn = data && data.isMobileSpeakerOn;
                    digest();
                })
                .catch(function (e) {
                    logService.log('checkCurrentMobileOutput Error:', e);
                });
        }

        function onMobileHeadsetChangeDetected() {
            self.checkCurrentMobileOutput();
        }

        function openHelpMenuWebinar() {
            if ($window.angular.element('#toggle-help').hasClass('open') === false) {
                analyticsWrapperService.eventTrack('Meeting - Webinar Help Menu Open', {
                    category: 'Header menu'
                });
            }
        }

        function openHelpMenuMeeting() {
            if ($window.angular.element('#open-support-site').hasClass('open') === false) {
                analyticsWrapperService.eventTrack('Meeting - Meeting Help Menu Open', {
                    category: 'Header menu'
                });
            }
        }

        function leaveMeeting() {
            logger.log('leaveMeeting', 'calling headerCtrl.leaveMeeting ...');
            const isHost = attendeeService.getIsHost();

            //we show this dialog instead of the swal below for electron app ... both host/attendees
            if (helperService.isElectron()) {
                camaroService.setIsMeetingInitiated();
                $rootScope.$broadcast('show-modal', 'camaroLeaveSelection');
                return;
            }

            if (!isHost) {
                if (self.isMobile) {
                    navigator.notification.confirm(
                        'Are you sure you want to leave the meeting?', // message
                        function (buttonIndex) {
                            if (buttonIndex === 2) {
                                localStorage.setItem('logged-in-meeting', false);
                                logger.log(
                                    'leaveMeeting',
                                    'calling terminate from attendee mobile callback in headerCtrl.leaveMeeting'
                                );
                                socketService.terminate(self.attendantId);
                            }
                        }, // callback
                        'Exit Meeting', // title
                        ['Stay', 'Leave Meeting'] // buttonName
                    );
                } else {
                    const closeButtonLeaveHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal(
                        {
                            title:
                                closeButtonLeaveHtml + localizationService.translate('HEADER.DIALOG.LEAVE_THE_MEETING'),
                            text:
                                '<div class="sweetalert-text-fix-size">' +
                                localizationService.translate('HEADER.DIALOG.ARE_YOU_SURE_YOU_WANT_TO_LEAVE_MEETING') +
                                '</div>',
                            showCancelButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            confirmButtonText: localizationService.translate('HEADER.DIALOG.LEAVE_MEETING'),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            closeOnConfirm: true,
                            html: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-exit.svg',
                            customClass: 'leave-meeting-url-modal auto-size'
                        },
                        function (isConfirmed) {
                            if (isConfirmed === true) {
                                logger.log(
                                    'leaveMeeting',
                                    'calling terminate from attendee redesign callback in headerCtrl.leaveMeeting'
                                );
                                self.performLeaveMeeting();
                            }
                        }
                    );
                }
            } else {
                if (self.isMobile) {
                    navigator.notification.confirm(
                        'What would you like to do?', // message
                        function (buttonIndex) {
                            if (buttonIndex === 2) {
                                localStorage.setItem('logged-in-meeting', false);
                                logger.log(
                                    'leaveMeeting',
                                    'calling terminate from host mobile callback in headerCtrl.leaveMeeting'
                                );
                                socketService.terminate(self.attendantId);
                            } else if (buttonIndex === 3) {
                                $timeout(function () {
                                    self.endMeeting();

                                    $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
                                }, 500);
                            }
                        }, // callback
                        'Exit Meeting', // title
                        ['Stay', 'Leave Meeting', 'End Meeting'] // buttonName
                    );
                } else {
                    if (helperService.getIsRedesign() === true) {
                        const closeButtonHtml =
                            '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                        $window.swal(
                            {
                                title: closeButtonHtml + localizationService.translate('HEADER.DIALOG.END_THE_MEETING'),
                                text:
                                    '<div class="sweetalert-text-fix-size">' +
                                    localizationService.translate(
                                        'HEADER.DIALOG.ENDING_THE_MEETING_WILL_DISCONNECT_EVERYONE'
                                    ) +
                                    '</div>',
                                type: 'input',
                                inputValue: meetingService.getExitUrl(),
                                showCancelButton: true,
                                confirmButtonColor: brandingService.getBaseColor(),
                                confirmButtonText: localizationService.translate('HEADER.DIALOG.END_MEETING_FOR_ALL'),
                                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                                closeOnConfirm: true,
                                html: true,
                                imageUrl: 'img/redesign/modal/pop-up-pic-exit.svg',
                                customClass: 'end-meeting-url-modal auto-size'
                            },
                            function (inputValue) {
                                if (inputValue === false) {
                                    return false;
                                }

                                if (inputValue !== '') {
                                    socketService.send({ message: 'meeting-end-redirect', data: inputValue });
                                }

                                $timeout(function () {
                                    annotationService.disconnect();
                                    self.endMeeting();

                                    uniteNotificationService.sendMeetingEndingEvent();

                                    $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
                                }, 500);
                            }
                        );
                    } else {
                        //TODO: REMOVE POST-REDESIGN
                        $window.swal(
                            {
                                title: localizationService.translate('HEADER.DIALOG.END_THE_MEETING'),
                                text: localizationService.translate(
                                    'HEADER.DIALOG.AFTER_MEETING_REDIRECT_GUESTS_TO_URL'
                                ),
                                type: 'input',
                                inputValue: meetingService.getExitUrl(),
                                showCancelButton: true,
                                confirmButtonColor: brandingService.getBaseColor(),
                                confirmButtonText: localizationService.translate('HEADER.DIALOG.END_THE_MEETING'),
                                closeOnConfirm: true,
                                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT')
                            },
                            function (inputValue) {
                                if (inputValue === false) {
                                    return false;
                                }

                                if (inputValue !== '') {
                                    socketService.send({ message: 'meeting-end-redirect', data: inputValue });
                                }

                                $timeout(function () {
                                    annotationService.disconnect();
                                    self.endMeeting();

                                    $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
                                }, 500);
                            }
                        );
                    }
                }
            }
        }

        function performLeaveMeeting(e, options) {
            socketService.terminate(self.attendantId, options);
            annotationService.disconnect();

            uniteNotificationService.sendMeetingLeftEvent();

            var userCache = cookieService.getObject('userCache');
            if (userCache) {
                userCache.autologin = false;
                var inAYear = new Date();
                inAYear.setDate(inAYear.getYear() + 1);
                cookieService.putObject('userCache', userCache, { expires: inAYear, secure: true, samesite: 'strict' });
            }
        }

        function getActiveDeviceLabels() {
            var deferred = $q.defer();

            avDeviceService
                .getActiveDevices()
                .then(function (activeDevices) {
                    self.activeAudioInputLabel =
                        activeDevices && activeDevices.audioInput ? activeDevices.audioInput.label : '';
                    self.activeAudioOutputLabel =
                        activeDevices && activeDevices.audioOutput ? activeDevices.audioOutput.label : '';
                    digest();

                    //empty timeout to ensure labels are updated in DOM before resolving
                    $timeout(function () {
                        deferred.resolve();
                    });
                })
                .catch(function (err) {
                    logger.error('getActiveDeviceLabels', 'Unable to retrieve active devices', err);
                    deferred.reject(err);
                });

            return deferred.promise;
        }

        //Determines if device dropdown feature is visible to the user
        function isDeviceDropdownEnabled(mediaType) {
            if (helperService.isMobile()) {
                return false;
            }

            if (mediaType === 'audio' && connectivityService.getAudioThroughPhone()) {
                return false;
            }

            if (mediaType === 'screen' && !meetingService.getIsSfuEnabled()) {
                return false;
            }

            return true;
        }

        //Determines if device dropdown feature is clickable by the user
        function isDeviceDropdownActive(mediaType) {
            var isActive = true;

            if (helperService.getIsRedesign()) {
                if (!self.isConferenceConnected() && mediaType !== 'audio') {
                    return false;
                }

                if (mediaType === 'video') {
                    if (attendeeService.getIsWaitingForVideoUpdate()) {
                        isActive = false;
                    }
                } else if (mediaType === 'screen') {
                    isActive = !self.isContentInitiating || self.getHasMultishare();
                }
            } else {
                if (!self.isConferenceConnected()) {
                    return false;
                }

                if (mediaType === 'audio') {
                    isActive = avDeviceService.getDevicePermissions().audioAllowed ? true : false;
                } else if (mediaType === 'video') {
                    if (attendeeService.getIsWaitingForVideoUpdate()) {
                        isActive = false;
                    } else {
                        isActive = avDeviceService.getDevicePermissions().videoAllowed ? true : false;
                    }
                } else if (mediaType === 'screen') {
                    isActive = !self.isContentInitiating || self.getHasMultishare();
                }
            }

            return isActive;
        }

        function attachDeviceDropdownEventListeners() {
            $window.$('#toggle-mic').on('show.bs.dropdown', self.onDeviceDropdownToggled);
            $window.$('#toggle-mic').on('hide.bs.dropdown', self.onDeviceDropdownToggled);
            $window.$('#toggle-cam').on('show.bs.dropdown', self.onDeviceDropdownToggled);
            $window.$('#toggle-cam').on('hide.bs.dropdown', self.onDeviceDropdownToggled);

            //when clicking on an item in a dropdown that gets open by using the dropdown attribute
            //it will automatically get closed. this prevents the dropdown from automatically closing
            //when clicking on specific element, namely list item that has a keep-open attribute
            $window.$('.lv-item[keep-open]').on('click', function (evt) {
                evt.stopPropagation();
            });
        }

        function onDeviceDropdownToggled(ev) {
            try {
                var toggleState = ev.type === 'show' ? 'open' : 'close'; //type is either 'show' or 'hide'
                var mediaType = ev.target.id.replace('-device-dropdown', ''); //id is either 'audio-device-dropdown' or 'video-device-dropdown'

                if (mediaType === 'video' && toggleState === 'close') {
                    // Fetch all the video's listed and call destroyVideoElement on each
                    const videoList = $window.$('#video-device-dropdown video');
                    for (var i = 0; i < videoList.length; i++) {
                        self.VDIRef.destroyVideoElement(videoList[i]);
                    }
                }

                self.clearDeviceList();

                if (toggleState === 'open') {
                    self.isWebcamAvailable = true;
                    // This analytics event is intentionally generic (should not mention media type)
                    analyticsWrapperService.eventTrack('Meeting - Opening device dropdown list', {
                        category: 'Header menu'
                    });

                    if (mediaType === 'audio' && self.usingTelephone()) {
                        logService.log('skipping media device check since phone only state');
                        return;
                    }

                    if (!self.VDIRef.showMultipleVideoStreams && mediaType === 'video') {
                        self.isVideoDeviceDropdownOpen = true;
                    }

                    //Gather devices
                    avDeviceService
                        .enumerateDevices()
                        .then(function () {
                            if (mediaType === 'audio') {
                                self.populateDeviceList(avDeviceService.deviceTypes.AUDIO_INPUT);
                                self.populateDeviceList(avDeviceService.deviceTypes.AUDIO_OUTPUT);
                            } else if (mediaType === 'video') {
                                self.populateDeviceList(avDeviceService.deviceTypes.VIDEO_INPUT);
                            } else {
                                //Shouldn't ever happen, but logging just in case
                                logService.log('Unknown media type:', mediaType);
                            }
                        })
                        .catch(function (err) {
                            logService.log('enumerateDevices error:', err);
                        });
                } else {
                    if (!self.VDIRef.showMultipleVideoStreams) {
                        self.isVideoDeviceDropdownOpen = false;
                        helperService.removePreviewVideoElement();
                    }
                }
            } catch (e) {
                logService.log('Error on device dropdown toggled:', e);
            }
        }

        function toggleDeviceDropdown($event, mediaType) {
            if ($event && $event.stopPropagation) {
                //Prevent mic/webcam toggle click event
                $event.stopPropagation();
            }

            // Check security setting
            if (mediaType === 'screen' && !self.isSharingScreenOrVideoAllowed()) {
                return;
            }

            if (!self.isDeviceDropdownActive(mediaType)) {
                return;
            }

            try {
                var dropdownContainerRawElement = $event.currentTarget;
                var dropdownContainerJqueryElement = $window.$(dropdownContainerRawElement);
                var dropdownjQueryElement = dropdownContainerJqueryElement.next('.dropdown-menu');

                dropdownjQueryElement.dropdown('toggle');

                if (mediaType === 'audio' && helperService.isDefaultMutedStateNotificationVisible()) {
                    self.hideDefaultMutedStateNotification();
                }
            } catch (e) {
                logService.log('Unable to toggle device dropdown:', e);
            }
        }

        function isDeviceDropdownOpen(mediaType) {
            var isDropdownOpen = false;

            if (mediaType === 'audio') {
                isDropdownOpen =
                    $window.$('#audio-device-dropdown') && $window.$('#audio-device-dropdown').hasClass('open');
            } else if (mediaType === 'video') {
                isDropdownOpen =
                    $window.$('#video-device-dropdown') && $window.$('#video-device-dropdown').hasClass('open');
            } else if (mediaType === 'screen') {
                isDropdownOpen =
                    $window.$('#screen-device-dropdown') && $window.$('#screen-device-dropdown').hasClass('open');
            }

            return isDropdownOpen;
        }

        function attachRedesignDropdownEventListeners() {
            if (helperService.getIsRedesign()) {
                logService.log('Attaching redesign dropdown listeners');

                var iconIds = [
                    '#toggle-mic',
                    '#toggle-cam',
                    '#share-desktop',
                    '#toggle-more',
                    '#open-support-site',
                    '#toggle-layout',
                    '#toggle-reaction'
                ];

                iconIds.forEach(function (iconId) {
                    $window.$(iconId).on('show.bs.dropdown', function () {
                        self.onDropdownToggled('show');
                    });

                    $window.$(iconId).on('hide.bs.dropdown', function () {
                        self.onDropdownToggled('hide');
                    });
                });
            }
        }

        function onDropdownToggled(dropdownState) {
            if (helperService.getIsRedesign()) {
                //If dropdown is open, header auto-hide should be disabled
                if (dropdownState === 'show') {
                    $rootScope.$broadcast('enable-header-auto-hide', { enable: false, reason: 'device-dropdown' });
                    self.hideVideosInMeetingVDI();
                } else if (dropdownState === 'hide') {
                    $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'device-dropdown' });
                    self.showVideosInMeetingVDI();
                } else {
                    logService.log('Unsupported dropdownState:', dropdownState);
                }
            }
        }

        function testAudioOutput($event, deviceObj) {
            if ($event && $event.stopPropagation) {
                //Prevent mic/webcam toggle click event
                $event.stopPropagation();
            }

            if (deviceObj && deviceObj.deviceInfo) {
                logService.log('Testing audio output for:', deviceObj.deviceInfo.label);

                try {
                    var audioElement = $window.$('#sound-test-src')[0];

                    if (audioElement) {
                        //If already playing, stop and reset
                        if (!audioElement.paused) {
                            audioElement.pause();
                            audioElement.currentTime = 0;
                        }

                        //Set audio output
                        audioElement.setSinkId(deviceObj.deviceInfo.deviceId);

                        //Play audio
                        audioElement.play();
                    }
                } catch (e) {
                    logService.log('Unable to test audio output:', e);
                }
            }
        }

        function openAVSettings() {
            if (helperService.getIsRedesign()) {
                if (!self.VDIRef.showMultipleVideoStreams) {
                    self.clearDeviceList();
                    if (self.isVideoDeviceDropdownOpen) {
                        helperService.removePreviewVideoElement();
                        self.isVideoDeviceDropdownOpen = false;
                    }
                    $timeout(function () {
                        $rootScope.$broadcast('show-modal', 'meetingSettings');
                    }, 1000);
                } else {
                    $rootScope.$broadcast('show-modal', 'meetingSettings');
                }
            } else {
                $rootScope.$broadcast('show-modal', 'micWebcamOptions');
            }
        }

        function switchToDevice(deviceObj) {
            if (deviceObj && deviceObj.deviceInfo) {
                logService.log('Switching to device:', deviceObj.deviceInfo.label, deviceObj.deviceInfo.deviceId);

                // This analytics event is intentionally generic (should not mention device info)
                analyticsWrapperService.eventTrack('Meeting - New device selected from dropdown list', {
                    category: 'Header menu'
                });

                var deviceStorageName;
                let ecdMethodName;
                switch (deviceObj.deviceInfo.kind) {
                    case 'audioinput':
                        deviceStorageName = 'audio-device';
                        ecdMethodName = 'setExplicitlyChosenAudioIn';
                        break;
                    case 'audiooutput':
                        deviceStorageName = 'audio-output-device';
                        ecdMethodName = 'setExplicitlyChosenAudioOut';
                        break;
                    case 'videoinput':
                        deviceStorageName = 'video-device';
                        ecdMethodName = 'setExplicitlyChosenVideo';
                        break;
                }

                if (deviceObj.deviceInfo.deviceId === storageService.get(deviceStorageName)) {
                    if (
                        deviceObj.deviceInfo.kind !== 'audioinput' ||
                        localStreamManagerService.isLocalAudioTrackActive()
                    ) {
                        logService.log('Device already in use... returning');
                        return;
                    }
                }

                if (
                    self.VDIRef.getVdiType() !== executionEnvironmentEnum.Citrix &&
                    deviceObj.deviceInfo.kind !== 'audiooutput' &&
                    !deviceObj.stream
                ) {
                    logService.log('Device has an error... returning');
                    return;
                }

                if (
                    helperService.getVDIRef().fetchAudioStreamAfterDeviceSwitch &&
                    deviceObj.deviceInfo.kind === 'audioinput'
                ) {
                    var audioOnlyConstraints = avDeviceService.generateConstraints(
                        'audio',
                        deviceObj.deviceInfo.deviceId
                    );
                    avDeviceService
                        .getStream(audioOnlyConstraints)
                        .then(function (audioOnlyStream) {
                            logService.log('HeaderCtrl - Successully retrieved audio-only stream');
                        })
                        .catch(function (audioOnlyStreamRetrievalError) {
                            logService.log(
                                'HeaderCtrl - Error retrieving video-only stream',
                                audioOnlyStreamRetrievalError
                            );
                        });
                }

                storageService.set(deviceStorageName, deviceObj.deviceInfo.deviceId);

                if (meetingService.getIsSfuEnabled()) {
                    avDeviceSettingsService[ecdMethodName](
                        deviceObj.deviceInfo.deviceId,
                        deviceObj.deviceInfo.originalLabel
                    );
                    avDeviceService.setDeviceErrors({ camError: false, micError: false });
                }

                var audioInputChanged = deviceObj.deviceInfo.kind === 'audioinput';
                var audioOutputChanged = deviceObj.deviceInfo.kind === 'audiooutput';
                var videoInputChanged = deviceObj.deviceInfo.kind === 'videoinput';

                // Newer Chrome & Electron versions can replace video tracks without hanging up.
                // Setting a new input source should be only used for Verto calls (Webinars).
                if (
                    !localStreamManagerService.shouldUseDeprecatedSpecForStreams() &&
                    !meetingService.getIsSfuEnabled()
                ) {
                    if (audioInputChanged) {
                        vertoService.setNewAudioInputSource(deviceObj.deviceInfo.deviceId, deviceObj.stream);
                    }

                    if (videoInputChanged) {
                        vertoService.setNewVideoInputSource(deviceObj.deviceInfo.deviceId, deviceObj.stream);
                    }
                }

                if (audioOutputChanged && !meetingService.getIsSfuEnabled()) {
                    vertoService.setNewAudioOutputSource(deviceObj.deviceInfo.deviceId);
                }

                //For older Chrome & Electron, this event will trigger Verto hangup and new call
                $rootScope.$broadcast('finished-media-device-selection', {
                    newVideoInputDeviceSelected: videoInputChanged,
                    newAudioInputDeviceSelected: audioInputChanged,
                    newAudioOutputDeviceSelected: audioOutputChanged
                });
            }
        }

        function populateDeviceList(deviceType) {
            var fromArray, toArray, deviceLoadingType;
            var noStream = false;

            switch (deviceType) {
                case avDeviceService.deviceTypes.AUDIO_INPUT:
                    fromArray = avDeviceService.microphones;
                    toArray = self.microphoneDevices;
                    deviceLoadingType = 'audioInput';
                    break;

                case avDeviceService.deviceTypes.AUDIO_OUTPUT:
                    fromArray = avDeviceService.speakers;
                    toArray = self.speakerDevices;
                    deviceLoadingType = 'audioOutput';
                    break;

                case avDeviceService.deviceTypes.VIDEO_INPUT:
                    fromArray = avDeviceService.webcams;
                    toArray = self.webcamDevices;
                    deviceLoadingType = 'videoInput';
                    break;
            }

            if (Array.isArray(fromArray) && Array.isArray(toArray)) {
                if (fromArray.length > 0) {
                    self.devicesLoading[deviceLoadingType] = true;
                    fromArray.forEach(function (mediaDeviceInfo, index, array) {
                        var ignoreGettingStreamFromSystemDevice = false;
                        if (
                            deviceLoadingType === 'audioInput' &&
                            !configService.getFixDeviceListEnabled() &&
                            index === 0
                        ) {
                            //ignore getting stream for first audio device aka the system setting device
                            ignoreGettingStreamFromSystemDevice = true;
                        }

                        if (
                            (!self.VDIRef.showMultipleVideoStreams &&
                                deviceLoadingType === 'videoInput' &&
                                localStreamManagerService.getCurrentWebcamStreamForVDI()) ||
                            (!self.VDIRef.showMultipleVideoStreams && deviceLoadingType !== 'videoInput')
                        ) {
                            // VDI - Show published active video stream in preview instead of calling getUserMedia.
                            noStream = true;
                        }
                        if (
                            self.VDIRef.showMultipleVideoStreams ||
                            !(deviceLoadingType === 'videoInput' && !avDeviceService.isDeviceInUse(mediaDeviceInfo))
                        ) {
                            avDeviceService
                                .generateDeviceObj(
                                    mediaDeviceInfo,
                                    index + 1,
                                    noStream || ignoreGettingStreamFromSystemDevice
                                )
                                .then(function (newDeviceObj) {
                                    if (newDeviceObj.deviceInfo) {
                                        if (newDeviceObj.deviceInfo.deviceId === 'default') {
                                            newDeviceObj.deviceInfo.sanitizedLabel =
                                                newDeviceObj.deviceInfo.sanitizedLabel +
                                                ' - ' +
                                                newDeviceObj.deviceInfo.originalLabel.replace('Default -', '').trim();
                                        } else if (newDeviceObj.deviceInfo.deviceId === 'communications') {
                                            newDeviceObj.deviceInfo.sanitizedLabel =
                                                newDeviceObj.deviceInfo.sanitizedLabel +
                                                ' - ' +
                                                newDeviceObj.deviceInfo.originalLabel
                                                    .replace('Communications -', '')
                                                    .trim();
                                        }
                                    }
                                    toArray.push(newDeviceObj);
                                    if (
                                        virtualBackgroundService.hasVirtualBackground() &&
                                        newDeviceObj.inUse &&
                                        deviceLoadingType === 'videoInput'
                                    ) {
                                        if (videoFilterService.getActiveFeedStream()) {
                                            self.webcamDevices.forEach(function (device) {
                                                if (device.inUse) {
                                                    device.stream = videoFilterService.getActiveFeedStream();
                                                }
                                            });
                                        } else {
                                            var filter = {};
                                            filter.deviceId = newDeviceObj.deviceInfo.deviceId;
                                            filter.value = virtualBackgroundService.getVirtualBackground() || 'none';
                                            virtualBackgroundService.requestFilteredBackgroundStream(filter, 'header');
                                        }
                                    }
                                })
                                .catch(function (err) {
                                    logService.log('Unable to generate device obj:', err);
                                })
                                .finally(function () {
                                    if (
                                        index === array.length - 1 ||
                                        (!self.VDIRef.showMultipleVideoStreams && toArray.length > 0)
                                    ) {
                                        self.devicesLoading[deviceLoadingType] = false;
                                    }
                                });
                        }
                    });
                }
                if (!self.VDIRef.showMultipleVideoStreams) {
                    $timeout(() => {
                        if (self.isVideoDeviceDropdownOpen) {
                            // When user selects a new device from dropdown to view the preview, it results in blank/black
                            // screen with Citrix SDK. In order to handle this we remove the existing video element from
                            // the DOM, create a new one and then attach stream to it.
                            helperService.createPreviewVideoElement();
                            self.webcamDevices.forEach(function (device) {
                                if (device.inUse) {
                                    const el = $window.$('#video-only-container > #video-preview')[0];
                                    if (noStream) {
                                        $window.Janus.attachMediaStream(
                                            el,
                                            localStreamManagerService.getCurrentWebcamStreamForVDI()
                                        );
                                    } else {
                                        $window.Janus.attachMediaStream(el, device.stream);
                                    }
                                }
                            });
                            if (self.webcamDevices.length === 0) {
                                self.isWebcamAvailable = false;
                            }
                        }
                    }, 2000);
                }
            } else {
                logService.log(
                    'Unable to populate ' + deviceLoadingType + ' dropdown device list due to invalid array'
                );
            }
        }

        function clearDeviceList() {
            avDeviceService.stopMicLevelTrackingForPreview();

            var micAndWebcamDevices = self.microphoneDevices.concat(self.webcamDevices);
            micAndWebcamDevices.forEach(function (deviceObj, index, array) {
                if (deviceObj.inUse && videoFilterService.getActiveFeedStream()) {
                    logService.log("header - don't stop stream because it is being used");
                } else if (deviceObj && deviceObj.stream) {
                    if (deviceObj.stream.stop) {
                        deviceObj.stream.stop();
                    }

                    if (deviceObj.stream.getTracks) {
                        deviceObj.stream.getTracks().forEach(function (track) {
                            track.stop();
                        });
                    }
                }

                if (index === array.length - 1) {
                    self.microphoneDevices = [];
                    self.webcamDevices = [];
                    digest();
                }
            });
            virtualBackgroundService.stopFilteredBackgroundStream('header');

            self.speakerDevices = [];

            digest();
        }

        function isVideoStreamActive(videoStream) {
            var isActive = false;

            if (
                (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix ||
                    self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware) &&
                localStreamManagerService.getCurrentWebcamStreamForVDI()
            ) {
                return true;
            }

            if (videoStream && videoStream.getVideoTracks) {
                var track = videoStream.getVideoTracks()[0];
                if (track && track.readyState === 'live') {
                    isActive = true;
                }
            }

            return isActive;
        }

        function stopPropagation($event) {
            if ($event && $event.stopPropagation) {
                //Prevent parent element toggle click event
                $event.stopPropagation();
            }
        }

        function toggleAudio() {
            attendeeService.toggleAudio(self.attendantId);
            self.hasShownDefaultMutingStateInfo = true; //This will force-skip the Default Mute State popover
        }

        function toggleTelephoneAudio() {
            $rootScope.$broadcast('toggle-telephone-audio', self.attendantId);
        }

        function toggleRecording() {
            if (self.isWebinar() && !self.isOnAir()) {
                $window.swal({
                    type: 'warning',
                    title: localizationService.translate('HEADER.DIALOG.CANNOT_START_RECORDING_TITLE'),
                    text: localizationService.translate('HEADER.DIALOG.CANNOT_START_RECORDING_TEXT'),
                    showCancelButton: false,
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OKAY_TEXT'),
                    closeOnConfirm: true
                });

                return;
            }

            recordingService.toggleRecording();
        }

        function isRecordingEnabled() {
            return self.isHost && !meetingService.e2eeEnabled() && !helperService.isVideoRoomApplication();
        }

        function showVirtualAssistantLanguageSelection() {
            // virtual assistant is not available in e2ee meeting
            if (meetingService.e2eeEnabled()) {
                return;
            }

            //prevent multiple toggling of add virtual assistant
            if (self.transcriptionActive()) {
                return;
            }

            if (localizationService.isEnLocale()) {
                self.addVirtualAssistant();
            } else {
                if (self.modalsAvailable) {
                    modalHelperService.openVirtualAssistantLanguageSelectionModal();
                } else {
                    $rootScope.$broadcast('show-modal', 'virtualAssistantLanguageSelection');
                }
            }
        }

        function onVALanguageSet(e, data) {
            if (data && data.languageCode) {
                self.addVirtualAssistant(data.languageCode);
            }
        }

        function addVirtualAssistant(languageCode) {
            if (attendeeService.getIsHost() && meetingService.hasTranscriptionEnabled()) {
                logService.log('starting addVirtualAssistant');
                var data = {};
                if (languageCode) {
                    data.languageCode = languageCode;
                }

                socketService.send({
                    message: 'add-virtual-assistant',
                    data: data
                });
            }
        }

        function onFsWsConnected() {
            if (self.shouldStartVirtualAssistantOnHostJoin()) {
                self.virtualAssistantWasRunOnHostJoin = true;
                self.showVirtualAssistantLanguageSelection();
            }
        }

        function shouldStartVirtualAssistantOnHostJoin() {
            return (
                self.virtualAssistantWasRunOnHostJoin === false &&
                configService.getValue('enableVAOnStart') === 'true' &&
                attendeeService.getIsHost(true) &&
                !meetingService.isWebinar() &&
                !helperService.isVideoRoomApplication()
            );
        }

        function onUpdateLocalAudioState() {
            self.isAudioMuted = attendeeService.getIsAudioMuted();
            digest();
        }

        function onForceVmute(e, data) {
            logService.log('Forcing vmute from server');
            attendeeService.toggleVideoOff();

            let title =
                data && !isNaN(data.newWebcamLimit)
                    ? localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.WEBCAM_LIMIT_RESET_TO', {
                          limit: data.newWebcamLimit
                      })
                    : localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.WEBCAM_LIMIT_RESET');

            if (self.isWebcamLimitLoweredNotificationVisible()) {
                self.hideWebcamLimitLoweredNotification();
            }

            self.setupWebcamLimitLoweredNotification(
                title,
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.WE_APOLOGIZE_FOR_INCONVENIENCE'),
                self.showWebcamLimitLoweredNotification
            );
        }

        function toggleVideo() {
            //If going from 0 to 1 feed, un-vBlind first, then toggle video
            if (
                !meetingService.getIsSfuEnabled() &&
                !vertoService.getIsVertoFeedVisible() &&
                attendeeService.getIsVideoMuted()
            ) {
                attendeeService.setIsWaitingForVideoUpdate(true);
                attendeeService.setVideoBlind(false, attendeeService.toggleVideo);
                return;
            }

            attendeeService.toggleVideo();
        }

        function onUpdateLocalVideoState() {
            self.isVideoMuted = attendeeService.getIsVideoMuted();
            digest();
        }

        function preToggleScreenShareCheck(shouldEndScreenShare, event, start) {
            return new Promise(resolve => {
                // Check security setting
                if (self.isSharingScreenOrVideoAllowed() === false) {
                    resolve();
                    return;
                }

                if (meetingService.isWebinar()) {
                    if (pollingService.getIsVoting()) {
                        $window.swal({
                            title: localizationService.translate('HEADER.DIALOG.SCREEN_DURING_POLL.TITLE'),
                            text: localizationService.translate('HEADER.DIALOG.SCREEN_DURING_POLL.TEXT'),
                            confirmButtonColor: brandingService.getBaseColor(),
                            type: 'warning'
                        });

                        resolve();
                        return;
                    }

                    if (questionService.getIsInQandAMode()) {
                        $window.swal({
                            title: localizationService.translate('HEADER.DIALOG.SCREEN_DURING_QANDA.TITLE'),
                            text: localizationService.translate('HEADER.DIALOG.SCREEN_DURING_QANDA.TEXT'),
                            confirmButtonColor: brandingService.getBaseColor(),
                            type: 'warning'
                        });

                        resolve();
                        return;
                    }
                }

                resolve(self.toggleScreenShare(shouldEndScreenShare, event, start));
            });
        }

        function toggleScreenShare(shouldEndScreenShare, event, start) {
            return screenShareService.getHasScreensharePermission().then(hasScreensharePermission => {
                //Disable this function if content already initiating
                if (self.isContentInitiating) {
                    return;
                }

                self.isVDIScreenShareConnected = contentService.getIsLocalContentShared();
                if (self.VDIRef.preventScreenShareStartIfAlreadyInitializing && self.isScreenShareReadyToInitialize) {
                    // Prevent screenshare from restarting if already ready to initialize on VDI
                    return;
                }

                if (self.VDIRef.preventScreenShareStartIfAlreadyInitializing && !self.isVDIScreenShareConnected) {
                    self.isScreenShareReadyToInitialize = true;
                }

                analyticsWrapperService.eventTrack('Meeting - Clicked Screenshare button', {
                    category: 'Header menu'
                });

                if (meetingService.getIsSfuEnabled()) {
                    analyticsWrapperService.eventTrack('Meeting - Clicked Screenshare button', {
                        category: 'Header menu',
                        sfuEvent: true
                    });
                }

                if (!meetingService.getIsSfuEnabled() && !screenShareService.getExtensionInstalled()) {
                    screenShareService.showInstallationPrompt(self.email);
                    logService.log('ScreenShare button clicked from Header - Showing Installation Prompt');
                    return;
                }

                if (!hasScreensharePermission && event) {
                    event.stopPropagation();
                    self.toggleDeviceDropdown(
                        { currentTarget: $window.$('#screen-device-dropdown .dropdown-toggler') },
                        'screen'
                    );
                    return screenShareService.triggerScreensharePermissionsSystemDialog();
                }

                if (self.isScreenVideo) {
                    // screen video playing, that should be stopped first.
                    $rootScope.$broadcast('stop-sfu-screenshare');
                    logService.log('ScreenShare button clicked from Header - Stopping screen video');
                } else if (!contentService.isContentPlaying()) {
                    if (self.isCompactMode && self.connectivity.state != 'disconnected') {
                        $rootScope.$broadcast('enable-compact-mode', false);
                    }

                    //No content playing, or start new in multishare, allow screenshare
                    if (meetingService.getIsSfuEnabled() && !helperService.isElectron()) {
                        $rootScope.$broadcast('start-sfu-screenshare');
                    } else {
                        //Electron should still call this if in SFU mode
                        $rootScope.$broadcast('start-screenshare');
                    }
                    logService.log('ScreenShare button clicked from Header - Starting Screenshare');
                } else {
                    var multisharePrompt = configService.getServerValue('multisharePrompt') || 'true'; // default is true
                    var hasMultishare = self.getHasMultishare();

                    if (hasMultishare && self.isCompactMode) {
                        $rootScope.$broadcast('enable-compact-mode', false);
                    }

                    if (
                        hasMultishare &&
                        multisharePrompt != 'true' &&
                        contentService.getContentOwner() !== self.attendantId &&
                        !contentService.getIsFilePlay() &&
                        helperService.getIsRedesign() === true
                    ) {
                        // automatically start multishare, without prompt
                        logService.log('ScreenShare starting as secondary without prompt');
                        contentService.startNewContent('screenshare');
                    } else if (contentService.getContentOwner() !== self.attendantId) {
                        //If you are not the owner, show override prompt
                        contentService.promptUserOverride('screenshare', undefined, undefined, hasMultishare);
                        logService.log(
                            "ScreenShare button clicked from Header - Calling promptUserOverride to override another user's content"
                        );
                    } else if (
                        !self.isScreenShareConnected ||
                        (start === true && (!meetingService.getIsSfuEnabled() || contentService.getIsFilePlay())) ||
                        (contentService.getIsFilePlay() && !shouldEndScreenShare)
                    ) {
                        //If you are the owner, but the current content is not screenshare, show override prompt
                        contentService.promptUserOverride('screenshare', undefined, undefined, hasMultishare);
                        logService.log(
                            "ScreenShare button clicked from Header - Calling promptUserOverride to override user's own content"
                        );
                    } else {
                        //If you are the owner, and the current content is screenshare, stop current content
                        contentService.stopCurrentContent();
                        logService.log('ScreenShare button clicked from Header - Calling stopCurrentContent');
                    }
                }

                return;
            });
        }

        function updateContentStatus(initiating, connected, owner, fileplay) {
            logService.log(
                'Updating headerCtrl content status - ' +
                    'Initiating: ' +
                    initiating +
                    ', Connected: ' +
                    connected +
                    ', Owner: ' +
                    owner
            );

            self.isContentInitiating = initiating;
            self.isScreenShareConnected = connected;
            self.isContentOwner = owner;
            self.isFilePlay = fileplay;

            digest();
        }

        function onContentInit(e, data) {
            var contentInit = true;
            var screenShareConnected = false;
            var contentOwner = data.ownerID === self.attendantId;

            updateContentStatus(contentInit, screenShareConnected, contentOwner, false);
        }

        function onContentInitCancelled(e, data) {
            var contentInit = false;
            var screenShareConnected = false;
            var contentOwner = false;

            updateContentStatus(contentInit, screenShareConnected, contentOwner, false);
        }

        function onContentPlaying(e, data) {
            var contentInit = false;
            var screenShareConnected = data.type === 'screenshare';
            var contentOwner = self.isContentOwner;
            var fileplay = !!data.isFilePlay;

            if (!contentOwner) {
                self.showSharedContent = true;
                self.toggleShowSharedContent();
            }

            updateContentStatus(contentInit, screenShareConnected, contentOwner, fileplay);
        }

        function onContentStopped(e, data) {
            var contentInit = false;
            var screenShareConnected = false;
            var contentOwner = false;

            updateContentStatus(contentInit, screenShareConnected, contentOwner, false);
        }

        function onContentStatus(e, data) {
            //Prevents unnecessary scope digests for people who already have screenshare status
            if (self.attendantId !== data.requesterID) {
                return;
            }

            var contentInit = data.state === 'initiating';
            var screenShareConnected = data.type === 'screenshare' && data.state === 'running';
            var contentOwner = data.ownerID === self.attendantId;
            var fileplay = !!data.isFilePlay;

            updateContentStatus(contentInit, screenShareConnected, contentOwner, fileplay);
        }

        function onSfuScreenVideoState(e, data) {
            self.isScreenVideo = (data && data.value) || false;
            digest();
        }

        function toggleMobileChatAttendeeTabs() {
            $rootScope.$broadcast('toggle-mobile-chat-attendee-tabs');
        }

        function shouldShowDefaultMutedStateNotification() {
            if (self.usingTelephone()) {
                return false;
            }

            if (
                self.hasShownDefaultMutingStateInfo ||
                !avDeviceService.getDevicePermissions().audioAllowed ||
                meetingService.getHasShownDeviceSelectionModal()
            ) {
                return false;
            }

            if (helperService.getIsRedesign()) {
                return true;
            } else {
                return self.isAudioMuted;
            }
        }

        function isHeaderVisible() {
            //Looks for #meeting-active element with classname that includes word 'hidden'
            //When hiding the header, we add classnames with this convention
            return $window.$('#meeting-active[class*="controls-hidden"]').length === 0;
        }

        function onAttendeeTalkingWhileMuted() {
            if (self.isAudioDisconnected()) {
                return;
            }
            if (self.isHeaderVisible()) {
                self.setPopover(
                    $window.$('#toggle-mic'),
                    $window.$('#attendeeTalkingWithMutedMic').html(),
                    '#toggle-mic'
                );
            } else {
                self.setPopover($window.$('#mute-indicator'), $window.$('#attendeeTalkingWithMutedMic').html(), 'body');
            }

            self.showTalkingWhileMutedNotification();
        }

        function showTalkingWhileMutedNotification() {
            if (!self.isTalkingWhileMutedNotificationVisible()) {
                if (self.isHeaderVisible()) {
                    logService.log("onAttendeeTalkingWhileMuted - showing 'Talking While Muted' popover for Mic Icon");
                    self.togglePopover('#toggle-mic', 'show', { customClass: 'talking-while-muted' });
                    self.applyTalkingWhileMutedNotificationClosehandler();
                } else {
                    logService.log(
                        "onAttendeeTalkingWhileMuted - showing 'Talking While Muted' popover for Muted Icon"
                    );
                    self.togglePopover('#mute-indicator', 'show', {
                        ignoreAutoHide: true,
                        customClass: 'talking-while-muted'
                    });
                    self.applyTalkingWhileMutedHiddenHeaderNotificationClosehandler();
                }

                self.talkingWhileMutedNotificationTimeout = $timeout(function () {
                    self.talkingWhileMutedNotificationTimeout = null;
                    self.hideTalkingWhileMutedNotification();
                }, 5000);
            }
        }

        function onAttendeeAudioStatusChange(e, data) {
            if (!data.isSelfMuted && self.isTalkingWhileMutedNotificationVisible()) {
                self.hideTalkingWhileMutedNotification();
            }
        }

        function hideTalkingWhileMutedNotification() {
            logService.log("onAttendeeTalkingWhileMuted - hiding 'Talking While Muted' popover");

            $window.removeEventListener('mousemove', self.hideTalkingWhileMutedNotification);
            self.togglePopover('#toggle-mic', 'hide');
            self.togglePopover('#mute-indicator', 'hide', { ignoreAutoHide: true });

            if (self.talkingWhileMutedNotificationTimeout) {
                $timeout.cancel(self.talkingWhileMutedNotificationTimeout);
                self.talkingWhileMutedNotificationTimeout = null;
            }
        }

        function isTalkingWhileMutedNotificationVisible() {
            return (
                $window.$('#toggle-mic').find('.talking-with-muted-mic-popover-body').is(':visible') ||
                $window.$('#mute-indicator').find('.talking-while-muted-header-hidden-popover-body').is(':visible')
            );
        }

        function applyTalkingWhileMutedHiddenHeaderNotificationClosehandler() {
            //the show talking while muted function will close the popup after five seconds, but if it doesn't
            //then when the user moves their mouse the popup closes
            $window.addEventListener('mousemove', self.hideTalkingWhileMutedNotification);
        }

        function applyTalkingWhileMutedNotificationClosehandler() {
            //Adds the close button to the popover that is showing over the microphone header icon
            var closeBtn = $window.$('.popover .talking-with-muted-mic-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideTalkingWhileMutedNotification);
                }
            }
        }

        function setupDefaultMutedStateNotification() {
            if (self.hasShownDefaultMutingStateInfo || !avDeviceService.getDevicePermissions().audioAllowed) {
                return;
            }

            self.getActiveDeviceLabels()
                .catch(function (err) {
                    //Error logged in getActiveDeviceLabels... nothing to do here
                })
                .finally(function () {
                    self.setPopover(
                        $window.$('#toggle-mic'),
                        $window.$('#mutedMicPopoverContent').html(),
                        '#toggle-mic'
                    );

                    $window.angular.element($window).bind('resize', function () {
                        if (helperService.isDefaultMutedStateNotificationVisible()) {
                            self.togglePopover('#toggle-mic', 'show');
                        }
                        self.applyDefaultMutedStateNotificationCloseHandler();
                    });

                    $document.on('click', self.hideDefaultMutedStateNotification);
                });
        }

        function showDefaultMutedStateNotification() {
            if (
                !helperService.isDefaultMutedStateNotificationVisible() &&
                self.shouldShowDefaultMutedStateNotification()
            ) {
                self.hideTalkingWhileMutedNotification();
                $rootScope.$broadcast('stop-tracking-local-audio');

                self.togglePopover('#toggle-mic', 'show');
                self.hasShownDefaultMutingStateInfo = true;

                self.applyDefaultMutedStateNotificationCloseHandler();

                self.dismissDefaultMutingStateInfoTimer = $timeout(
                    self.hideDefaultMutedStateNotification,
                    1000 * 60,
                    true,
                    true
                );
            }
        }

        function applyDefaultMutedStateNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .muted-mic-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideDefaultMutedStateNotification);
                }
            }
        }

        function sendTrackLocalAudioWhileMutedEvent() {
            $rootScope.$broadcast('track-local-audio-while-muted', 'headerCtrl-hideDefaultMutedStateNotification');
        }

        function hideDefaultMutedStateNotification(keepClickListener) {
            if (helperService.isDefaultMutedStateNotificationVisible()) {
                self.togglePopover('#toggle-mic', 'hide');

                $timeout(sendTrackLocalAudioWhileMutedEvent, 2000);

                if (self.dismissDefaultMutingStateInfoTimer) {
                    $timeout.cancel(self.dismissDefaultMutingStateInfoTimer);
                    self.dismissDefaultMutingStateInfoTimer = null;
                }

                //If we have other document.click listeners in the app,
                //we should remove this to prevent interference
                if (!keepClickListener) {
                    $document.off('click', self.hideDefaultMutedStateNotification);
                }
            }
        }

        function onTopControlsOnboardingStarted() {
            self.hideDefaultMutedStateNotification(true);
            self.hidePhonePairNotification();
            self.hideMeetingLockedNotification();
        }

        function onTopControlsOnboardingFinished() {
            if (self.shouldShowDefaultMutedStateNotification()) {
                self.showDefaultMutedStateNotification();
            } else if (self.shouldShowPhonePairNotification()) {
                self.showPhonePairNotification();
            }

            if (meetingService.shouldShowUnlockNotification()) {
                self.showMeetingLockedNotification();
            }
        }

        //Leaving this in for now in case the event completes a UI refresh in the header
        function onFSConnectionComplete(e, data) {
            if (screenShareService.getExtensionInstalled()) {
                logService.log('screen share extension installed', { category: 'screen-share-extension' });
            } else {
                logService.log('screen share extension not installed', { category: 'screen-share-extension' });
            }

            if (!meetingService.isWebinar() && !helperService.isMobile()) {
                //Init popover notifications

                //This is done to retrieve values from the meetingg Service
                self.determineValuesForNotificationToShow();

                self.setupSecurityBetaSettingsNotification(
                    self.showJustBetaSettingNotification,
                    self.showJustSecuritySettingNotification
                );

                if (self.shouldShowDefaultMutedStateNotification()) {
                    self.setupDefaultMutedStateNotification();
                    $timeout(self.showDefaultMutedStateNotification, 2000);
                } else if (self.shouldShowPhonePairNotification()) {
                    self.setupPhonePairNotification();
                    $timeout(self.showPhonePairNotification, 2000);
                }

                if (meetingService.shouldShowUnlockNotification()) {
                    self.setupMeetingLockedNotification();
                    $timeout(self.showMeetingLockedNotification, 2000);
                }

                if (self.layoutLock) {
                    self.showLayoutLockNotification();
                    if (!attendeeService.getIsHost()) {
                        var host = attendeeListService.getHost();
                        logService.log(
                            'headerCtrl - sending fetch-videos-layout to ' + (host ? host.attendantId : 'no host')
                        );
                        if (host) {
                            socketService.send({
                                message: 'attendee-message',
                                data: { type: 'fetch-videos-layout', to: host.attendantId }
                            });
                        }
                    }
                }
            }

            if (helperService.isMobile()) {
                self.checkCurrentMobileOutput();
            }

            digest();
        }

        function isConferenceConnected() {
            return connectivityService.getConferenceConnected();
        }

        function onPhoneOnlyState(e, data) {
            self.phoneOnlyState = true;
            digest();
        }

        function digest() {
            $scope.$applyAsync();
        }

        function onTogglingConnectOverlay(e, obj) {
            //this is to allow fadeIn/fadeOut to work without
            //resorting to ngAnimate, which breaks the UI for us
            //Also this will prevent a brief flash at the beginning
            if (self.isLeftAligned) {
                logService.log('no progress indicator on mobile device');
                return;
            }

            self.fadeDuration = '1s';
            if (obj && obj.message) {
                self.message = obj.message;
            }
            if (obj && obj.showConnectOverlay !== 'undefined') {
                self.showConnectOverlay = obj.showConnectOverlay;
                self.connectOverlayInitiated = true;

                if (self.showConnectOverlay) {
                    self.hidePhonePairNotification();
                }
            }
            digest();
        }

        function isWebinarAttendee() {
            return meetingService.isWebinar() && attendeeService.getIsAttendee();
        }

        function hasToolbarMenu() {
            if (!meetingService.isWebinar() || helperService.isMobile()) {
                return true;
            }
            return capabilityService.hasCapability('shareFiles');
        }

        function hasSideToggle() {
            if (!meetingService.isWebinar()) {
                return true;
            } else {
                if (attendeeService.getIsPresenter()) {
                    return true;
                } else if (!self.isOnAir()) {
                    return false;
                } else {
                    var webinarOptions = meetingService.getWebinarOptions();
                    return webinarOptions.showAttendeeList || webinarOptions.showPublicChat;
                }
            }
        }

        function hasRecordingIcon() {
            if (helperService.getIsRedesign()) {
                if (self.isHost && !helperService.isVideoRoomApplication()) {
                    return true;
                } else {
                    return self.isRecording;
                }
            }

            if (self.phoneOnlyState) {
                return false;
            }

            if (self.isMobile && !self.isRecordingEnabled()) {
                return false;
            }

            if (!meetingService.isWebinar() || self.isHost) {
                return true;
            }

            return false;
        }

        function hasVirtualAssistantIcon() {
            if (
                helperService.getIsRedesign() &&
                !meetingService.isWebinar() &&
                attendeeService.getIsHost() &&
                meetingService.hasTranscriptionEnabled() &&
                !helperService.isVideoRoomApplication()
            ) {
                return true;
            }

            return false;
        }

        function canEnableQAMode() {
            if (meetingService.isWebinar() && attendeeService.getIsPresenter()) {
                return true;
            }
            return false;
        }

        function toggleQAMode() {
            $rootScope.$broadcast('show-modal', 'webinarPresenterQA');
        }

        function loadBugScript(cb) {
            if (self.loadedBugScript) {
                cb();
                return;
            }

            var targethead = window.document.getElementsByTagName('head')[0],
                jst = window.document.createElement('script');
            jst.async = true;
            jst.type = 'text/javascript';
            jst.src = '/lib/Bug/bug-min.js';
            jst.onload = jst.onreadystatechange = function () {
                if (!this.readyState || this.readyState === 'complete') {
                    self.loadedBugScript = true;
                    cb();
                }
            };
            targethead.appendChild(jst);
        }

        function setReaction(reaction, isReset) {
            self.currentReaction = reaction;

            var msgObj = {
                message: 'attendee-reaction-updated',
                data: { reaction: reaction, isReset: isReset }
            };

            socketService.send(msgObj);

            if (meetingService.isWebinar()) {
                setCurrentReactionTimeout();
            } else {
                if (reaction === 'snowflake') {
                    if (!self.snowflakes) {
                        self.snowflakes = new Snowflakes();
                        $timeout(function () {
                            self.snowflakes.stop();
                            self.snowflakes.destroy();
                            self.snowflakes = null;
                        }, 30000);
                    }
                } else if (reaction === 'spider') {
                    loadBugScript(() => {
                        if (self.spiders) {
                            self.spiders.end();
                        }
                        self.spiders = new BugController({
                            imageSprite: '/lib/Bug/spider-sprite.png',
                            bugWidth: 69,
                            bugHeight: 90,
                            num_frames: 7,
                            canFly: false,
                            canDie: true,
                            numDeathTypes: 2,
                            zoom: 6,
                            minDelay: 100,
                            maxDelay: 300,
                            minSpeed: 6,
                            maxSpeed: 13,
                            minBugs: 5,
                            maxBugs: 10
                        });

                        if (self.spidersTimeout) {
                            $timeout.cancel(self.spidersTimeout);
                            self.spidersTimeout = null;
                        }

                        self.spidersTimeout = $timeout(() => {
                            if (self.spiders) {
                                $window.$('.bug').animate(
                                    {
                                        opacity: 0
                                    },
                                    2000,
                                    () => {
                                        if (self.spiders) {
                                            self.spiders.end();
                                            self.spiders = null;
                                        }

                                        if (self.spidersTimeout) {
                                            self.spidersTimeout = null;
                                        }
                                    }
                                );
                            }
                        }, 30000);
                    });
                } else if (reaction === 'rabbit') {
                    if (!self.rabbit) {
                        self.rabbit = true;
                        $timeout(function () {
                            self.rabbit = false;
                        }, 10000);
                    }
                } else if (reaction === 'easter-eggs') {
                    if (!self.easterEggs) {
                        self.easterEggs = true;
                        $timeout(function () {
                            self.easterEggs = false;
                        }, 10000);
                    }
                }
            }

            self.isReactionMenuOpen = false;
            digest();
        }

        function resetReaction() {
            setReaction('fine', true);
        }

        function setCurrentReactionTimeout() {
            if (self.currentReactionTimer !== null) {
                $timeout.cancel(self.currentReactionTimer);
            }
            if (self.currentReaction !== 'fine') {
                self.currentReactionTimer = $timeout(function () {
                    resetReaction();
                }, 60000); //inject the service containing the webinar options if we want to configure this
            }
        }

        function getCurrentReaction() {
            return self.currentReaction;
        }

        function isReactionShown() {
            return self.isWebinarAttendee();
        }

        function isMeetingReactionShown() {
            return (
                meetingService.isMeeting() && meetingService.getMeetingReactionsOn() && self.VDIRef.showReactionButton
            );
        }

        function openReactionMenu() {
            self.isReactionMenuOpen = true;
            if (helperService.isMobile() && !helperService.isTablet()) {
                $rootScope.$broadcast('mobile-reaction-menu-opened');
                helperService.delayedWebRTCRefresh();
            }
            digest();
        }

        function closeReactionMenu() {
            self.isReactionMenuOpen = false;
            if (helperService.isMobile() && !helperService.isTablet()) {
                $rootScope.$broadcast('mobile-reaction-menu-closed');
                helperService.delayedWebRTCRefresh();
            }
            digest();
        }

        function polls_isVisible() {
            // meetingService.hasFeature('polls')
            // capabilityService.hasCapability('managePolls')
            return meetingService.isWebinar() && (attendeeService.getIsHost() || attendeeService.getIsPresenter());
        }

        function isPresenter() {
            return attendeeService.getIsPresenter();
        }

        function isOnAir() {
            var isOnAir = meetingService.getIsOnAir();

            if (self.phoneOnlyState) {
                return isOnAir;
            } else {
                return isOnAir && connectivityService.getConferenceConnected();
            }
        }

        function onSnapEngageAgentStatus(e, isOnline) {
            if (self.snapEngageAgentStatus !== isOnline) {
                self.snapEngageAgentStatus = isOnline;
                digest();
            }
        }

        function onShowMicUnpluggedNotification(e, data) {
            if (self.isMicUnpluggedNotificationVisible()) {
                self.hideMicUnpluggedNotification();
            }

            if (data && data.state) {
                var title = '';
                var deviceName = localStreamManagerService.currentLocalAudioTrack
                    ? localStreamManagerService.currentLocalAudioTrack.label
                    : '';

                switch (data.state) {
                    case 'reconnected-current-device':
                        title = localizationService.translate('HEADER.TOOLTIP.MICROPHONE_RECONNECTED_DEVICE');
                        break;
                    case 'connected-new-device':
                        title = localizationService.translate('HEADER.TOOLTIP.MICROPHONE_NEW_DEVICE');
                        break;
                    case 'no-device-connected':
                        title = localizationService.translate('HEADER.TOOLTIP.MICROPHONE_NO_ACTIVE_DEVICE');
                        deviceName = '';
                        break;
                }

                self.setupMicUnpluggedNotification(title, deviceName, self.showMicUnpluggedNotification);
            }
        }

        function onShowCamUnpluggedNotification(e, data) {
            if (self.isCamUnpluggedNotificationVisible()) {
                self.hideCamUnpluggedNotification();
            }

            $timeout(
                function () {
                    if (data && data.state) {
                        var title = '';
                        var deviceName = localStreamManagerService.currentLocalVideoTrack
                            ? localStreamManagerService.currentLocalVideoTrack.label
                            : '';

                        switch (data.state) {
                            case 'reconnected-current-device':
                                title = localizationService.translate('HEADER.TOOLTIP.WEBCAM_RECONNECTED_DEVICE');

                                // ANYAM-107084: localStreamManagerService.currentLocalVideoTrack.label has incorrect camera name in tooltip if VB enabled
                                var webcam = avDeviceService.getCurrentlySelectedWebcam();
                                if (webcam && webcam.label) {
                                    deviceName = webcam.label;
                                }
                                break;
                            case 'connected-new-device':
                                title = localizationService.translate('HEADER.TOOLTIP.WEBCAM_NEW_DEVICE');
                                break;
                            case 'no-device-connected':
                                title = localizationService.translate('HEADER.TOOLTIP.WEBCAM_NO_ACTIVE_DEVICE');
                                deviceName = '';
                                break;
                        }

                        self.setupCamUnpluggedNotification(title, deviceName, self.showCamUnpluggedNotification);
                    }
                },
                self.VDIRef.getVdiType() === executionEnvironmentEnum.VMware ? 1500 : 0
            );
        }

        function onDeviceChangeDetected() {
            if (
                self.isCamUnpluggedNotificationVisible() &&
                self.camUnpluggedTextTitle ===
                    localizationService.translate('HEADER.TOOLTIP.WEBCAM_NO_ACTIVE_DEVICE') &&
                avDeviceService.hasCamera()
            ) {
                logService.log(
                    "Webcam detected while 'no-device-connected' notification visible... hiding notification"
                );
                self.hideCamUnpluggedNotification();
            }

            if (
                self.isMicUnpluggedNotificationVisible() &&
                self.micUnpluggedTextTitle ===
                    localizationService.translate('HEADER.TOOLTIP.MICROPHONE_NO_ACTIVE_DEVICE') &&
                avDeviceService.hasMicrophone()
            ) {
                logService.log("Mic detected while 'no-device-connected' notification visible... hiding notification");
                self.hideMicUnpluggedNotification();
            }

            //If local audio track is not active, set an audio device error
            //This will allow user to be able to click the mic icon to attempt audio reconnection...
            if (
                !connectivityService.getAudioThroughPhone() &&
                self.isConferenceConnected() &&
                avDeviceService.hasMicrophone() &&
                !localStreamManagerService.isLocalAudioTrackActive() &&
                !avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device'))
            ) {
                avDeviceService.setSfuDeviceError(storageService.get('audio-device'), 'ended-unexpectedly');
            }

            //trigger click on page to close mic/speaker dropdown menu
            $('body').trigger('click');
        }

        function onJanusLocalMediaStreamCreated(e, data) {
            if (data && data.type === 'audio') {
                if (
                    self.isMicUnpluggedNotificationVisible() &&
                    self.micUnpluggedTextTitle ===
                        localizationService.translate('HEADER.TOOLTIP.MICROPHONE_NO_ACTIVE_DEVICE')
                ) {
                    logService.log(
                        "Audio stream created while 'no-device-connected' notification visible... hiding notification"
                    );
                    self.hideMicUnpluggedNotification();
                }
            } else if (data && data.type === 'video') {
                if (
                    self.isCamUnpluggedNotificationVisible() &&
                    self.camUnpluggedTextTitle ===
                        localizationService.translate('HEADER.TOOLTIP.WEBCAM_NO_ACTIVE_DEVICE')
                ) {
                    logService.log(
                        "Video stream created while 'no-device-connected' notification visible... hiding notification"
                    );
                    self.hideCamUnpluggedNotification();
                }
            }
        }

        function onVertoCallAudioInputUpdated() {
            //Hide notification now that new audio input stream has started
            if (
                self.isMicUnpluggedNotificationVisible() &&
                self.micUnpluggedTextTitle === 'You do not have an active microphone'
            ) {
                self.hideMicUnpluggedNotification();
            }
        }

        function isWebinar() {
            return meetingService.isWebinar();
        }

        function getScreenHeightAdjustment() {
            var height;
            if (self.isTablet) {
                height = 60;
            } else if (self.isMobile) {
                height = $window.screen.availWidth - 20;
            }
            if (height !== undefined) {
                return { height: height };
            }
            return '';
        }

        function getIsTalking() {
            if (attendeeService.getIsWaitingForAudioUpdate()) {
                return false;
            }

            if (self.usingTelephone() && !self.isTelephonePaired()) {
                return false;
            } else {
                if (self.isAudioMuted) {
                    return false;
                } else {
                    if (
                        !self.hasWebRTC ||
                        !self.hasMicrophone() ||
                        !self.isConferenceConnected() ||
                        (!avDeviceService.getDevicePermissions().audioAllowed && !self.isTelephonePaired())
                    ) {
                        return false;
                    }

                    if (self.isMicrophoneHavingAnIssue() && !self.isTelephonePaired()) {
                        return false;
                    }

                    return self.isTalking;
                }
            }
        }

        function getIsPermissionAllowedForType(type) {
            switch (type) {
                case 'audio':
                    return avDeviceService.getDevicePermissions().audioAllowed;
                case 'video':
                    return avDeviceService.getDevicePermissions().videoAllowed;
                default:
                    return false;
            }
        }

        function onAttendeePartialProperty(e, data) {
            if (data && data.attendantId === attendeeService.getAttendantId()) {
                if (data.propName && data.propName === 'isTalking') {
                    self.isTalking = data.propValue;
                    digest();
                }
            }
        }

        function onAttendeePartial(e, att) {
            if (att && att.attendantId === attendeeService.getAttendantId()) {
                self.isTalking = att.isTalking;
                digest();
            }
        }

        function onGetSharedFilesData(e, data) {
            self.sharedFiles = data.ids;
        }

        function onSharedFilesDataUpdated(e, data) {
            self.sharedFilesCounter =
                data.ids.length > self.sharedFilesCounter
                    ? data.ids.length - self.sharedFilesCounter
                    : self.sharedFilesCounter;
            self.sharedFiles = data.ids;
        }

        function onBrandingInfoUpdated() {
            var data = meetingService.getBrandingInfo();
            self.inMeetingLogo = data.inMeetingLogoURL;

            digest();
        }

        function isTelephonePaired() {
            return attendeeService.getIsPhonePaired();
        }

        function isMeetingLockedInitialized() {
            return meetingService.isLockedInitialized();
        }

        function onMeetingLockedToggled() {
            if (meetingService.getIsWaitingForLockUpdate()) {
                return;
            }

            logService.log('Sending new meetingLocked val to server:', { locked: !self.meetingLocked });

            // send analytics event only when lock meeting
            if (!self.meetingLocked) {
                analyticsWrapperService.eventTrack('Meeting - Locked');
            }

            meetingService.setAllowJoinRequests(true);
            sendSetMeetingLockedEvent(!self.meetingLocked, meetingService.getAllowJoinRequests());
            meetingService.setIsWaitingForLockUpdate(true);
        }

        function sendSetMeetingLockedEvent(meetingLocked, allowJoinRequests) {
            socketService.send({
                message: 'set-meeting-locked',
                data: {
                    meetingLocked: meetingLocked,
                    allowJoinRequests: allowJoinRequests
                }
            });
        }

        function shouldShowLockMeeting() {
            if (helperService.isVideoRoomApplication()) {
                return false;
            }

            var lockFeatureEnabledByConfig = capabilityService.hasCapability('lockMeeting');

            return lockFeatureEnabledByConfig || self.lockMeetingAllowed;
        }

        function onLockMeetingAllowed(e, data) {
            self.lockMeetingAllowed = data;
            digest();
        }

        function getLockMeetingAllowed() {
            var msg = {};
            msg.message = 'get-lock-meeting-allowed';
            msg.callback = function (data) {
                self.lockMeetingAllowed = data;
                digest();
            };
            socketService.send(msg);
        }

        function onUpdateLocalMeetingLocked() {
            self.meetingLocked = meetingService.getLocked();
            meetingService.setIsWaitingForLockUpdate(false);

            if (!self.meetingLocked) {
                self.hideMeetingLockedNotification();
            }

            digest();
        }

        function getLockTooltip() {
            if (meetingService.getIsWaitingForLockUpdate()) {
                return localizationService.translate('HEADER.TOOLTIP.PLEASE_WAIT');
            }

            if (self.meetingLocked) {
                return localizationService.translate('HEADER.TOOLTIP.UNLOCK_MEETING');
            }

            return localizationService.translate('HEADER.TOOLTIP.LOCK_MEETING');
        }

        function getConnectivityTooltip() {
            var connectivityObj;

            if (meetingService.getIsSfuEnabled()) {
                connectivityObj = {
                    iceConnectionState: connectivityService.getJanusSipCallIceState(),
                    packetLoss: {
                        state: connectivityService.getPacketLossState(),
                        streams: connectivityService.getStreams()
                    }
                };
            } else {
                connectivityObj = {
                    iceConnectionState: vertoService.getIceConnectionState(),
                    packetLoss: {
                        state: connectivityService.getPacketLossState(),
                        streams: connectivityService.getStreams()
                    },
                    bandwidth: {
                        up: vertoService.getAttendeeUploadBandwidth(),
                        down: vertoService.getAttendeeDownloadBandwidth()
                    }
                };
            }

            var isSelf = true;
            var firstName = null;

            return connectivityService.getConnectivityTooltip(connectivityObj, isSelf, firstName);
        }

        function getEndMeetingTooltip() {
            return attendeeService.getIsHost()
                ? localizationService.translate('HEADER.TOOLTIP.END_MEETING_AND_LOG_OUT_EVERYONE')
                : localizationService.translate('HEADER.TOOLTIP.LEAVE_THIS_MEETING');
        }

        function getOnAirIndicatorTooltip() {
            return self.isOnAir()
                ? localizationService.translate('HEADER.WEBINAR.YOU_ARE_NOW_ON_AIR')
                : localizationService.translate('HEADER.WEBINAR.YOU_ARE_NOW_OFF_AIR');
        }

        function getSwitchToPhoneTooltip() {
            if (self.e2eeEnabled()) {
                return localizationService.translate('DEVICE_SELECTION_PREVIEW.E2EE_PHONE_AUDIO_DISABLED');
            } else {
                return '';
            }
        }

        function onAttendeeConnectivityStateChanged() {
            var connectionState;
            var socketState;

            if (meetingService.getIsSfuEnabled()) {
                connectionState = connectivityService.getLocalConnectivityState();
                socketState = connectivityService.getJanusWSConnected() ? 'connected' : 'disconnected';
            } else {
                connectionState = vertoService.getIceConnectionState();
                socketState = vertoService.getSocketState(vertoService.getFSSocket());
            }

            switch (connectionState) {
                case 'new':
                case 'checking':
                case 'connecting':
                case 'unassigned':
                    self.connectivity.state = 'connecting';
                    break;

                case 'connected':
                case 'completed':
                    self.connectivity.state = socketState === 'connected' ? 'connected' : 'connecting';
                    self.connectivity.packetLossState = connectivityService.getPacketLossState();
                    if (helperService.getIsRedesign()) {
                        $rootScope.$broadcast('packet-loss-state', { state: self.connectivity.packetLossState });
                    }
                    break;

                default:
                    self.connectivity.state = 'disconnected';
            }

            logService.log(
                'Attendee connectivity state changed - ICE state: ' +
                    connectionState +
                    ' (' +
                    self.connectivity.state +
                    ')'
            );
        }

        /**
         * @returns {'webinar' | 'meeting'}
         */
        function getMeetingType() {
            return meetingService.isWebinar() ? 'webinar' : 'meeting';
        }

        function shouldShowConnectivityIcon() {
            var connectivityClass = self.getConnectivityClass();
            return connectivityClass.indexOf('high') > -1 || connectivityClass.indexOf('medium') > -1;
        }

        function getConnectivityClass(attendee) {
            if (!connectivityService.isLocalConnectvityConnected()) {
                return 'zmdi-wifi-off';
            }

            switch (connectivityService.getLocalConnectivityIconState()) {
                case 'low':
                    return 'zmdi-wifi-alt low';
                case 'medium':
                    return 'zmdi-wifi-alt-2 medium';
                case 'high':
                    return 'zmdi-wifi-info high';
            }

            return 'zmdi-wifi-alt low';
        }

        function getLocalConnectivityStateTooltip() {
            return meetingService.isWebinar()
                ? 'You are not connected to the webinar'
                : localizationService.translate('HEADER.TOOLTIP.YOU_ARE_NOT_CONNECTED_TO_MEETING');
        }

        function isAttendeeConnected() {
            return connectivityService.isLocalConnectvityConnected();
        }

        function shouldShowPhonePairNotification() {
            if (meetingService.isWebinar() || helperService.isMobile()) {
                return false;
            }

            if (!self.usingTelephone()) {
                return false;
            }

            if (connectivityService.getInitialAudioChoice() === 'no-audio') {
                return false;
            }

            if (self.hasShownPhonePairNotification) {
                return false;
            }

            return !attendeeService.getIsPhonePaired();
        }

        function shouldShowPhonePairToast() {
            if (meetingService.isWebinar() || helperService.isMobile()) {
                return false;
            }

            if (!self.usingTelephone()) {
                return false;
            }

            if (connectivityService.getInitialAudioChoice() === 'no-audio') {
                return false;
            }

            return attendeeService.getIsPhonePaired();
        }

        function getAudioPin() {
            return attendeeService.getAudioPin();
        }

        function setupMicUnpluggedNotification(title, body, cb) {
            self.micUnpluggedTextTitle = title;
            self.micUnpluggedTextBody = body;

            //Timeout is to allow time for micUnpluggedText to populate DOM before setting the popover
            $timeout(function () {
                self.setPopover(
                    $window.$('#toggle-mic'),
                    $window.$('#micUnpluggedPopoverContent').html(),
                    '#toggle-mic'
                );

                if (cb) {
                    cb();
                }
            }, 1000);
        }

        function showMicUnpluggedNotification() {
            if (!self.isMicUnpluggedNotificationVisible()) {
                self.togglePopover('#toggle-mic', 'show');
                self.applyMicUnpluggedNotificationCloseHandler();
            }
        }

        function hideMicUnpluggedNotification() {
            if (self.isMicUnpluggedNotificationVisible()) {
                self.togglePopover('#toggle-mic', 'hide');
                self.micUnpluggedTextTitle = '';
                self.micUnpluggedTextBody = '';
            }
        }

        function isMicUnpluggedNotificationVisible() {
            if (helperService.getIsRedesign()) {
                return $window.$('#toggle-mic').find('.mic-unplugged-popover-body').is(':visible');
            } else {
                return $window.$('#toggle-mic').next('.popover').find('.mic-unplugged-popover-body').is(':visible');
            }
        }

        function applyMicUnpluggedNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .mic-unplugged-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideMicUnpluggedNotification);
                }
            }
        }

        function setupCamUnpluggedNotification(title, body, cb) {
            self.camUnpluggedTextTitle = title;
            self.camUnpluggedTextBody = body;

            //Timeout is to allow time for micUnpluggedText to populate DOM before setting the popover
            $timeout(function () {
                self.setPopover(
                    $window.$('#toggle-cam'),
                    $window.$('#camUnpluggedPopoverContent').html(),
                    '#toggle-cam'
                );

                if (cb) {
                    cb();
                }
            }, 1000);
        }

        function showCamUnpluggedNotification() {
            if (!self.isCamUnpluggedNotificationVisible()) {
                self.togglePopover('#toggle-cam', 'show');
                self.applyCamUnpluggedNotificationCloseHandler();
            }
        }

        function hideCamUnpluggedNotification() {
            if (self.isCamUnpluggedNotificationVisible()) {
                self.togglePopover('#toggle-cam', 'hide');
                self.camUnpluggedTextTitle = '';
                self.camUnpluggedTextBody = '';
            }
        }

        function isCamUnpluggedNotificationVisible() {
            if (helperService.getIsRedesign()) {
                return $window.$('#toggle-cam').find('.cam-unplugged-popover-body').is(':visible');
            } else {
                return $window.$('#toggle-cam').next('.popover').find('.cam-unplugged-popover-body').is(':visible');
            }
        }

        function applyCamUnpluggedNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .cam-unplugged-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideCamUnpluggedNotification);
                }
            }
        }

        function setupWebcamLimitLoweredNotification(title, body, cb) {
            self.webcamLimitLoweredTextTitle = title;
            self.webcamLimitLoweredTextBody = body;

            //Timeout is to allow time for micUnpluggedText to populate DOM before setting the popover
            $timeout(function () {
                self.setPopover(
                    $window.$('#toggle-cam'),
                    $window.$('#webcamLimitLoweredPopoverContent').html(),
                    '#toggle-cam'
                );

                if (cb) {
                    cb();
                }
            }, 1000);
        }

        function showWebcamLimitLoweredNotification(newLimit) {
            if (!self.isWebcamLimitLoweredNotificationVisible()) {
                self.togglePopover('#toggle-cam', 'show', { reason: 'webcam-limit-lowered-popover' });
                self.applyWebcamLimitLoweredNotificationCloseHandler();
            }
        }

        function hideWebcamLimitLoweredNotification() {
            if (self.isWebcamLimitLoweredNotificationVisible()) {
                self.togglePopover('#toggle-cam', 'hide');
                self.webcamLimitLoweredTextTitle = '';
                self.webcamLimitLoweredTextBody = '';
            }
        }

        function isWebcamLimitLoweredNotificationVisible() {
            if (helperService.getIsRedesign()) {
                return $window.$('#toggle-cam').find('.webcam-limit-lowered-popover-content').is(':visible');
            } else {
                return $window
                    .$('#toggle-cam')
                    .next('.popover')
                    .find('.webcam-limit-lowered-popover-content')
                    .is(':visible');
            }
        }

        function applyWebcamLimitLoweredNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .webcam-limit-lowered-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideWebcamLimitLoweredNotification);
                }
            }
        }

        function getWebcamLimitLoweredTitle() {
            let title =
                data && !isNaN(data.newWebcamLimit)
                    ? localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.WEBCAM_LIMIT_RESET_TO', {
                          limit: data.newWebcamLimit
                      })
                    : localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.WEBCAM_LIMIT_RESET');
        }

        function setupPhonePairNotification() {
            if (self.hasShownPhonePairNotification) {
                return;
            }

            self.setPopover($('#toggle-mic'), $('#pairPhonePopoverContent').html(), '#toggle-mic');

            $window.angular.element($window).bind('resize', function () {
                if (self.isPhonePairNotificationVisible()) {
                    self.togglePopover('#toggle-mic', 'show');
                }
                self.applyPhonePairNotificationCloseHandler();
            });
        }

        function applyPhonePairNotificationCloseHandler() {
            var closeBtn = $('.popover .pair-phone-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hidePhonePairNotification);
                }
            }
        }

        function isPhonePairNotificationVisible() {
            if (helperService.getIsRedesign()) {
                return $window.$('#toggle-mic').find('.pair-phone-popover-title').is(':visible');
            } else {
                return $window.$('#toggle-mic').next('.popover').find('.pair-phone-popover-title').is(':visible');
            }
        }

        function showPhonePairNotification() {
            if (!self.isPhonePairNotificationVisible()) {
                self.togglePopover('#toggle-mic', 'show');
                self.hasShownPhonePairNotification = true;
                self.applyPhonePairNotificationCloseHandler();

                $timeout(function () {
                    self.hidePhonePairNotification();
                }, 1000 * 60);
            }
        }

        function hidePhonePairNotification() {
            if (self.isPhonePairNotificationVisible()) {
                self.togglePopover('#toggle-mic', 'hide');
            }
        }

        function onLocalPhonePairingStateUpdated(e, data) {
            if (self.shouldShowPhonePairNotification()) {
                self.setupPhonePairNotification();
                self.showPhonePairNotification();
            } else {
                self.hidePhonePairNotification();
            }

            if (self.shouldShowPhonePairToast()) {
                self.showPhonePairToast(data);
            }
        }

        function showPhonePairToast(pairedPhoneNumber) {
            var filteredPhoneNumber = $filter('phoneFilter')(pairedPhoneNumber);
            notificationService.show(
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.PAIRED_PHONE_NUMBER', {
                    phone: filteredPhoneNumber
                }),
                'success'
            );
        }

        function setupMeetingLockedNotification() {
            if (self.hasShownMeetingLockedNotification) {
                return;
            }

            self.setPopover($window.$('#lock'), $window.$('#meetingLockedPopoverContent').html());

            angular.element($window).bind('resize', function () {
                if (self.isMeetingLockedNotificationVisible()) {
                    self.togglePopover('#lock', 'show');
                }
                self.applyMeetingLockedNotificationCloseHandler();
            });
        }

        function applyMeetingLockedNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .meeting-locked-popover-close-btn i');
            if (closeBtn) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideMeetingLockedNotification);
                }
            }
        }

        function isMeetingLockedNotificationVisible() {
            return $window.$('#lock').next('.popover').find('.meeting-locked-popover-title').is(':visible');
        }

        function showMeetingLockedNotification() {
            if (!self.isMeetingLockedNotificationVisible()) {
                self.togglePopover('#lock', 'show');
                self.hasShownMeetingLockedNotification = true;
                self.applyMeetingLockedNotificationCloseHandler();
            }
        }

        function hideMeetingLockedNotification() {
            if (self.isMeetingLockedNotificationVisible()) {
                self.togglePopover('#lock', 'hide');
            }
        }

        function determineValuesForNotificationToShow() {
            //This is where we can pass the variable from the meeting service to wether the settings should be shown
            var valuesOfBetaAndSecuritySetting = meetingService.securityAndBetaSettingNotifications();
            var beta = valuesOfBetaAndSecuritySetting.betaValueChecked || self.shouldShowAdvancedSettingsNotification();
            var uncheckedSettings = valuesOfBetaAndSecuritySetting.securitySettingUnchecked;
            self.showJustSecuritySettingNotification = false;
            self.showJustBetaSettingNotification = false;
            //If the beta is checked and a security setting is unchecked
            if (beta && uncheckedSettings) {
                //And the user is the host
                if (attendeeService.getIsHost()) {
                    self.showJustBetaSettingNotification = true;
                    self.showJustSecuritySettingNotification = true;
                } else {
                    //if not the host just show beta setting is selected
                    self.showJustBetaSettingNotification = true;
                }
                //If  beta and the security settings are unchecked show just securitySetting notification
            } else if (!beta && uncheckedSettings && attendeeService.getIsHost()) {
                self.showJustSecuritySettingNotification = true;

                //if beta is checked and security settings are all checked show just beta notification
            } else if (beta && !uncheckedSettings) {
                self.showJustBetaSettingNotification = true;
            }
            digest();
        }

        function hasLGVFeature() {
            // TODO: Kundan will be refactoring this redundant code to use a service
            // NOTE: layoutPage URL param/user pair can potentially have other string values
            // such as “animateGoto:false,preferSquare:false” which is treated as if layoutPage is true
            if (_hasLGVFeature === undefined) {
                var value = configService.getValue('layoutPage');
                _hasLGVFeature = value && value != 'false';
            }

            return _hasLGVFeature;
        }

        function onLGVAvailable() {
            if (!self.hasLGVFeature()) {
                // return because the All Webcams View feature is not enabled
                return;
            }

            self.setupLGVNotification();
        }

        function setupLGVNotification() {
            if (!self.hasLGVFeature()) {
                // return because the All Webcams View feature is not enabled
                return;
            }

            if (self.hasShownLGVNotification) {
                // return because the All Webcams View notification was already shown
                return;
            }

            self.setPopover($window.$('#toggle-layout'), $window.$('#largeGalleryViewPopoverContent').html());

            try {
                $window.$('#toggle-layout').data('bs.popover').tip().addClass('lgv-popover');
            } catch (err) {
                logService.log('Error adding All Webcams View Popover Class', err);
            }

            angular.element($window).bind('resize', function () {
                if (self.isLGVNotificationVisible()) {
                    self.togglePopover('#toggle-layout', 'show');
                }
                self.applyLGVNotificationCloseHandler();
            });

            self.showLGVNotification();
        }

        // This shows the LGV popup setup in the setupLGVNotification
        function showLGVNotification() {
            if (!self.hasLGVFeature()) {
                // return because the All Webcams View feature is not enabled
                return;
            }

            // header control needs to be visible before popover is shown so it has correct position set
            if (helperService.getIsRedesign() && !self.isCompactMode) {
                $rootScope.$broadcast('enable-header-auto-hide', { enable: false, reason: 'header-popover' });
            }

            if (!self.isLGVNotificationVisible()) {
                $timeout(function () {
                    self.togglePopover('#toggle-layout', 'show');
                    self.hasShownLGVNotification = true;
                    self.applyLGVNotificationCloseHandler();
                }, 300); // without this, the arrow is not aligned to the box.

                self.dismissLGVTimer = $timeout(self.hideLGVNotification, 1000 * 6, true, true); // After 6 seconds, hide All Webcams View notification
            }
        }

        function isLGVNotificationVisible() {
            if (!self.hasLGVFeature()) {
                // return false because the All Webcams View feature is not enabled
                return false;
            }

            return $window.$('#toggle-layout').next('.popover').find('.lgv-popover-title').is(':visible');
        }

        // This hides the LGV popup setup in the setupLGVNotification
        function hideLGVNotification() {
            if (!self.hasLGVFeature()) {
                // return because the All Webcams View feature is not enabled
                return;
            }

            if (self.isLGVNotificationVisible()) {
                self.togglePopover('#toggle-layout', 'hide');

                if (self.dismissLGVTimer) {
                    $timeout.cancel(self.dismissLGVTimer);
                    self.dismissLGVTimer = null;
                }
            }
        }

        function applyLGVNotificationCloseHandler() {
            if (!self.hasLGVFeature()) {
                // return because the All Webcams View feature is not enabled
                return;
            }

            var closeBtn = $window.$('.popover .lgv-popover-close-btn i');
            if (closeBtn && closeBtn.length > 0) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideLGVNotification);
                }
            }
        }

        //This function sets up the popovers for these situations:
        //If there is securityAndBeta, this means that a security box by the host is unchecked and a beta box is checked, showing the large notification
        //if there is justBeta it means just a beta box is checked and it will show the host/attendee a notification
        //If there is justSecurity means that at least one security box is unchecked by the host and gives the host a notification
        function setupSecurityBetaSettingsNotification(showBeta, showSecurity) {
            if (self.VDIRef.getVdiType() === executionEnvironmentEnum.Citrix) {
                return;
            }
            if (showBeta && showSecurity) {
                if (self.hasShownSecurityBetaSettingsNotification) {
                    return;
                }

                self.setPopover($window.$('#toggle-more'), $window.$('#securityBetaSettingsPopoverContent').html());

                try {
                    $window.$('#toggle-more').data('bs.popover').tip().addClass('security-and-beta-setting-popover');
                } catch (err) {
                    logService.log('Errored on adding Security and Beta Setting Popover Class', err);
                }
                angular.element($window).bind('resize', function () {
                    if (self.isSecurityAndBetaSettingsNotificationVisible()) {
                        self.togglePopover('#toggle-more', 'show');
                    }
                    self.applySecurityBetaSettingsNotificationCloseHandler();
                });

                $timeout(self.showSecurityBetaSettingsNotification, 2000);
            } else if (showBeta) {
                if (self.hasShownBetaSettingsNotification) {
                    return;
                }

                self.setPopover($window.$('#toggle-more'), $window.$('#betaSettingsPopoverContent').html());

                try {
                    $window.$('#toggle-more').data('bs.popover').tip().addClass('security-or-beta-setting-popover');
                } catch (err) {
                    logService.log('Errored on adding Beta Setting Popover Class', err);
                }
                angular.element($window).bind('resize', function () {
                    if (self.isBetaSettingsNotificationVisible()) {
                        self.togglePopover('#toggle-more', 'show');
                    }
                    self.applySecurityBetaSettingsNotificationCloseHandler();
                });

                $timeout(self.showSecurityBetaSettingsNotification, 2000);
            } else if (showSecurity) {
                if (self.hasShownSecuritySettingsNotification) {
                    return;
                }

                self.setPopover($window.$('#toggle-more'), $window.$('#securitySettingsPopoverContent').html());

                try {
                    $window.$('#toggle-more').data('bs.popover').tip().addClass('security-or-beta-setting-popover');
                } catch (err) {
                    logService.log('Errored on adding Security Setting Popover Class', err);
                }

                angular.element($window).bind('resize', function () {
                    if (self.isSecuritySettingsNotificationVisible()) {
                        self.togglePopover('#toggle-more', 'show');
                    }
                    self.applySecurityBetaSettingsNotificationCloseHandler();
                });

                $timeout(self.showSecurityBetaSettingsNotification, 2000);
            }
        }

        //This hides the popups described in the setupSecurityBetaSettingsNotification
        function hideSecurityBetaSettingsNotification() {
            if (
                self.isSecurityAndBetaSettingsNotificationVisible() ||
                self.isBetaSettingsNotificationVisible() ||
                self.isSecuritySettingsNotificationVisible()
            ) {
                self.togglePopover('#toggle-more', 'hide');

                if (self.dismissSecuritySettingsTimer) {
                    $timeout.cancel(self.dissmissSecurityBetaSettingsTimer);
                    self.dismissSecurityBetaSettingsTimer = null;
                }
            }
        }

        //This shows the popups described in the setupSecurityBetaSettingsNotification
        function showSecurityBetaSettingsNotification() {
            var showBeta = self.showJustBetaSettingNotification;
            var showSecurity = self.showJustSecuritySettingNotification;

            //header control needs to be visible before popover is shown so it has correct position set
            if (showBeta || showSecurity) {
                if (helperService.getIsRedesign() && !self.isCompactMode) {
                    $rootScope.$broadcast('enable-header-auto-hide', { enable: false, reason: 'header-popover' });
                }
            }

            if (showBeta && showSecurity) {
                if (!self.isSecurityAndBetaSettingsNotificationVisible()) {
                    $timeout(function () {
                        self.togglePopover('#toggle-more', 'show');
                        self.hasShownSecurityBetaSettingsNotification = true;
                        self.applySecurityBetaSettingsNotificationCloseHandler();
                    }, 300); // without this, the arrow is not aligned to the box.

                    self.dismissSecurityBetaSettingsTimer = $timeout(
                        self.hideSecurityBetaSettingsNotification,
                        1000 * 6,
                        true,
                        true
                    );
                }
            } else if (showBeta) {
                if (!self.isBetaSettingsNotificationVisible()) {
                    $timeout(function () {
                        self.togglePopover('#toggle-more', 'show');
                        self.hasShownBetaSettingsNotification = true;
                        self.applySecurityBetaSettingsNotificationCloseHandler();
                    }, 300); // without this, the arrow is not aligned to the box.

                    self.dismissBetaSettingsTimer = $timeout(
                        self.hideSecurityBetaSettingsNotification,
                        1000 * 6,
                        true,
                        true
                    );
                }
            } else if (showSecurity) {
                if (!self.isSecuritySettingsNotificationVisible()) {
                    $timeout(function () {
                        self.togglePopover('#toggle-more', 'show');
                        self.hasShownSecuritySettingsNotification = true;
                        self.applySecurityBetaSettingsNotificationCloseHandler();
                    }, 300); // without this, the arrow is not aligned to the box.

                    self.dismissSecuritySettingsTimer = $timeout(
                        self.hideSecurityBetaSettingsNotification,
                        1000 * 6,
                        true,
                        true
                    );
                }
            }
        }

        function getBetaSettingContentText() {
            var contentText = '';
            var betaSettingOn = meetingService.securityAndBetaSettingNotifications().betaValueChecked;
            if (betaSettingOn && self.shouldShowAdvancedSettingsNotification()) {
                contentText = localizationService.translate('HEADER.TOOLTIP.ADVANCED_AND_BETA_FEATURE_MSG');
            } else if (self.shouldShowAdvancedSettingsNotification()) {
                contentText = localizationService.translate('HEADER.TOOLTIP.ADVANCED_FEATURE_OFF_MSG');
            } else if (betaSettingOn) {
                contentText = localizationService.translate(
                    'SECURITY_SETTINGS.NOTIFICATION.HOST_EXPERIMENTAL_FEATURES_ACTION'
                );
            }
            return contentText;
        }

        function getBetaSettingTitleText() {
            var titleText = '';
            var betaSettingOn = meetingService.securityAndBetaSettingNotifications().betaValueChecked;
            if (betaSettingOn && self.shouldShowAdvancedSettingsNotification()) {
                titleText = localizationService.translate('HEADER.TOOLTIP.ADVANCED_AND_BETA_FEATURE_ON');
            } else if (self.shouldShowAdvancedSettingsNotification()) {
                titleText = localizationService.translate('HEADER.TOOLTIP.ADVANCED_FEATURE_ON');
            } else if (betaSettingOn) {
                titleText = localizationService.translate(
                    'SECURITY_SETTINGS.NOTIFICATION.NOTIFY_HOST_EXPERIMENTAL_FEATURES'
                );
            }
            return titleText;
        }

        //This applies the close handler if a user closes a pop up that appears if a beta box is checked or a security setting is unchecked
        function applySecurityBetaSettingsNotificationCloseHandler() {
            var closeBtn = $window.$('.popover .security-beta-settings-popover-close-btn i');
            if (closeBtn && closeBtn.length > 0) {
                if (!closeBtn.hasClass('click-event-bound')) {
                    closeBtn.addClass('click-event-bound').click(self.hideSecurityBetaSettingsNotification);
                }
            }
        }

        function isSecurityAndBetaSettingsNotificationVisible() {
            return $window
                .$('#toggle-more')
                .next('.popover')
                .find('.security-beta-settings-popover-title')
                .is(':visible');
        }

        function isSecuritySettingsNotificationVisible() {
            return $window.$('#toggle-more').next('.popover').find('.security-settings-popover-title').is(':visible');
        }

        function isBetaSettingsNotificationVisible() {
            return $window.$('#toggle-more').next('.popover').find('.beta-settings-popover-title').is(':visible');
        }

        function shouldShowAdvancedSettingsNotification() {
            var data = JSON.parse(storageService.get('advancedSettings') || '{}');
            delete data.videoLow;
            var size = (self.advancedSettingsSize = (data && Object.keys(data).length) || 0);
            return size > 0;
        }

        function setPopover(element, content, container) {
            const placement = element.attr('data-placement');
            if (element.data('bs.popover')) {
                element.data('bs.popover').options.html = true;
                element.data('bs.popover').options.container = container;
                element.data('bs.popover').options.content = content;
                if (placement) {
                    element.data('bs.popover').options.placement = placement;
                }
            } else {
                const popObj = {
                    html: true,
                    trigger: 'manual',
                    content: content
                };
                if (placement) {
                    popObj.placement = placement;
                }

                if (helperService.getIsRedesign() && container) {
                    popObj.container = container;
                }
                element.popover(popObj);
            }
        }

        function onPhoneStateUpdated() {
            if (!connectivityService.getAudioThroughPhone()) {
                //If switching to mic, hide Phone-Pair notification
                self.hidePhonePairNotification();

                if (self.shouldShowDefaultMutedStateNotification()) {
                    //Users switching to mic for the first time
                    //after they've already connected to the meeting
                    //
                    //This popover needs more time to setup, which is
                    //why the timeout is needed
                    self.setupDefaultMutedStateNotification();
                    $timeout(self.showDefaultMutedStateNotification, 1000);
                }
            } else if (self.shouldShowPhonePairNotification() && self.isConferenceConnected()) {
                //This case accounts for users switching to phone for the first time
                //After they've already connected to the meeting
                self.setupPhonePairNotification();
                self.showPhonePairNotification();
            }
        }

        function hasMicrophoneDeviceError() {
            return avDeviceService.hasMicrophoneDeviceError();
        }

        function isMicrophoneHavingAnIssue() {
            return avDeviceService.isMicrophoneHavingAnIssue();
        }

        function hasWebcamDeviceError() {
            return avDeviceService.hasWebcamDeviceError();
        }

        function isWebcamHavingAnIssue() {
            return avDeviceService.isWebcamHavingAnIssue();
        }

        function onConnectivityClick(event) {
            var data = {
                shiftKey: event.shiftKey,
                altKey: event.altKey,
                ctrlKey: event.ctrlKey,
                metaKey: event.metaKey
            };
            $rootScope.$broadcast('toggle-connection-stats', data);
        }

        function togglePopover(elementId, popoverState, opts) {
            opts = opts || {};

            if (typeof elementId !== 'string') {
                logger.error('togglePopover', 'Unable to toggle popover due to invalid element ID', elementId);
            } else if (popoverState === 'show' || popoverState === 'hide') {
                if (helperService.getIsRedesign() && !opts.ignoreAutoHide && !self.isCompactMode) {
                    //Header auto-hide is enabled if popover is not visible
                    $rootScope.$broadcast('enable-header-auto-hide', {
                        enable: popoverState === 'hide',
                        reason: opts.reason ? opts.reason : 'header-popover'
                    });
                }

                if (opts.customClass) {
                    try {
                        $window.$(elementId).popover().data('bs.popover').tip().addClass(opts.customClass);
                    } catch (e) {
                        logger.error('togglePopover', 'Error adding custom class to popover', e);
                    }
                }

                $window.$(elementId).popover(popoverState);
            } else {
                logger.error('togglePopover', 'Invalid popover state', popoverState);
            }
        }

        function getStringForVideoShareState() {
            return contentService.isContentPlaying() &&
                contentService.getContentOwner() == self.attendantId &&
                contentService.getContentType() === 'screenshare' &&
                contentService.getIsFilePlay()
                ? localizationService.translate('HEADER.SETTINGS.STOP_SHARE_VIDEO')
                : localizationService.translate('HEADER.SETTINGS.SHARE_VIDEO');
        }

        function getStringForScreenShareState() {
            return (self.isScreenVideo ||
                (contentService.isContentPlaying() &&
                    contentService.getContentOwner() == self.attendantId &&
                    contentService.getContentType() === 'screenshare')) &&
                contentService.getIsFilePlay() == false
                ? localizationService.translate('HEADER.SETTINGS.STOP_SHARE_SCREEN')
                : localizationService.translate('HEADER.SETTINGS.SHARE_SCREEN');
        }

        function openMicCamPermissionTroubleShootPage() {
            var kbArticle = supportLinkService.getSupportLink('allowMicChrome');
            $window.open(kbArticle, '_blank');
        }

        function openCameraSystemPreference() {
            macSecurityPreferencesService.openCamera();
        }

        function openScreenShareSystemPreference() {
            macSecurityPreferencesService.openScreenCapture();
        }

        function openMicrophoneSystemPreference() {
            macSecurityPreferencesService.openMicrophone();
        }

        function openMicCamPermissionTroubleShootPageForElectron() {
            var kbArticle = supportLinkService.getSupportLink('catalinaScreenShare');
            return $window.open(kbArticle, '_blank');
        }

        function shouldShowScreenSharePermissionErrorState() {
            return screenShareService.getHasScreensharePermission().then(hasScreensharePermission => {
                return !hasScreensharePermission;
            });
        }

        function deviceHasError(deviceId) {
            return avDeviceService.getSfuDeviceErrorFromId(deviceId);
        }

        function isAudioReconnectAllowed() {
            return (
                avDeviceService.hasMicrophone() &&
                avDeviceService.getSfuDeviceErrorFromId(storageService.get('audio-device')) &&
                self.isConferenceConnected()
            );
        }

        function openLayoutToggleDropdown() {
            if ($window.angular.element('#toggle-layout').hasClass('open') === false) {
                analyticsWrapperService.eventTrack('Meeting - Toggle Layout Dropdown Open', {
                    category: 'Header menu'
                });

                self.hideLGVNotification();
            }
        }

        function getGridviewLayoutToggleTooltip() {
            if (attendeeService.getIsHost() === false && self.layoutLock === true) {
                // attendee while layout is locked
                return localizationService.translate('HEADER.SETTINGS.HOST_LAYOUT_LOCK_ATTENDEE_TOOLTIP');
            } else {
                return localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.GALLERY');
            }
        }

        function getLargeGalleryViewLayoutToggleTooltip() {
            if (attendeeService.getIsHost() === false && self.layoutLock === true) {
                // attendee while layout is locked
                return localizationService.translate('HEADER.SETTINGS.HOST_LAYOUT_LOCK_ATTENDEE_TOOLTIP');
            } else {
                return localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.ALL_WEBCAMS_VIEW');
            }
        }

        function getSpotlightLayoutToggleTooltip() {
            if (attendeeService.getIsHost() === false && self.layoutLock === true) {
                // attendee while layout is locked
                return localizationService.translate('HEADER.SETTINGS.HOST_LAYOUT_LOCK_ATTENDEE_TOOLTIP');
            } else {
                return localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.SPOTLIGHT');
            }
        }

        function getCompactLayoutToggleTooltip() {
            if (attendeeService.getIsHost() === false && self.layoutLock === true) {
                // attendee while layout is locked
                return localizationService.translate('HEADER.SETTINGS.HOST_LAYOUT_LOCK_ATTENDEE_TOOLTIP');
            } else {
                return localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.ENABLE_COMPACT_MODE');
            }
        }

        function getToggleLayoutTooltip(isFeedActive) {
            return isFeedActive
                ? localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.TOGGLE_ENABLED')
                : localizationService.translate('HEADER.TOGGLE_LAYOUT.TOOLTIP.TOGGLE_DISABLED');
        }

        function onSecurityToggled() {
            if (self.isSecurityToggleDisabled()) {
                return;
            }

            var isHost = self.isHost;

            var closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';

            if (!meetingService.e2eeEnabled()) {
                analyticsWrapperService.eventTrack('Meeting - E2EE - enable', { isHost: isHost });

                if (isHost) {
                    var promptMsg =
                        '<span class="security-notification-title">' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.MESSAGE') +
                        '</span>';
                    promptMsg += '<br/>';
                    promptMsg += localizationService.translate('HEADER.SECURITY.NOTIFICATION.DISABLED_FEATURES');
                    promptMsg += '<br/><ul>';
                    promptMsg +=
                        '<li>' + localizationService.translate('HEADER.SECURITY.NOTIFICATION.RECORDING') + '</li>';
                    promptMsg +=
                        '<li>' + localizationService.translate('HEADER.SECURITY.NOTIFICATION.VIDEO_SHARING') + '</li>';
                    promptMsg += '<li>' + localizationService.translate('HEADER.SECURITY.NOTIFICATION.CHAT') + '</li>';
                    promptMsg += '<li>' + localizationService.translate('HEADER.SECURITY.NOTIFICATION.NOTES') + '</li>';
                    promptMsg +=
                        '<li>' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.PHONE_AUDIO_SUPPORT') +
                        '</li>';
                    promptMsg +=
                        '<li>' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.VIRTUAL_BACKGROUND') +
                        '</li>';
                    promptMsg +=
                        '<li>' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.ALL_WEBCAMS_VIEW', {
                            max_users: meetingService.getE2EEMaxUsers()
                        }) +
                        '</li>';
                    promptMsg +=
                        '<li>' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.VIRTUAL_ASSISTANT') +
                        '</li>';
                    promptMsg += '</ul><br/>';
                    promptMsg +=
                        '<div id="unsupported-attendees-removed-block"><img src="/img/redesign/icons/ic-alarm.svg" /><div id="unsupported-attendees-removed-text">' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.UNSUPPORTED_ATTENDEES_REMOVED') +
                        '</div></div>';
                    promptMsg +=
                        '<div id="additional-info">' +
                        localizationService.translate('HEADER.SECURITY.NOTIFICATION.ADDITIONAL_INFO') +
                        '</div>';

                    $window.swal(
                        {
                            title:
                                closeButtonHtml + localizationService.translate('HEADER.SECURITY.NOTIFICATION.TITLE'),
                            text: promptMsg,
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('COMMON.ENABLE_TEXT'),
                            imageUrl: 'img/redesign/modal/key.svg',
                            customClass: 'security-notification-modal',
                            html: true
                        },
                        function (confirmed) {
                            if (confirmed) {
                                if (self.hasE2EEUnsupportedMobileAppUsers()) {
                                    $rootScope.$broadcast('show-modal', 'unsupportedE2EEncryptionAttendees');
                                } else {
                                    if (self.modalsAvailable) {
                                        modalHelperService.openCreateE2eEncryptionKeyModal();
                                    } else {
                                        $rootScope.$broadcast('show-modal', 'createE2EEncryptionKey');
                                    }
                                }
                            } else {
                                analyticsWrapperService.eventTrack(
                                    'Meeting - E2EE - Host interrupted encryption enabling'
                                );
                            }
                        }
                    );
                }
            } else {
                analyticsWrapperService.eventTrack('Meeting - E2EE - disable', { isHost: isHost });

                if (isHost) {
                    var title = localizationService.translate('HEADER.SECURITY.NOTIFICATION.DISABLE_ENCRYPTION.HEADER');
                    var message = localizationService.translate(
                        'HEADER.SECURITY.NOTIFICATION.DISABLE_ENCRYPTION.MESSAGE'
                    );
                    $window.swal(
                        {
                            title: closeButtonHtml + title,
                            text: message,
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('COMMON.DISABLE_TEXT'),
                            customClass: 'security-notification-modal',
                            html: true
                        },
                        function (confirmed) {
                            if (confirmed) {
                                $rootScope.$broadcast('disable-e2ee');
                            }
                        }
                    );
                }
            }
        }

        function onE2EEToggled() {
            self.onSecurityToggled();
        }

        function shouldShowSecurityToggle() {
            const isSupportedElectronApp = !helperService.isElectronApp || helperService.isUniteApp;

            return (
                meetingService.hasFeature('e2ee') &&
                meetingService.getE2EEAvailable() &&
                (self.isHost || meetingService.e2eeEnabled()) &&
                isSupportedElectronApp
            );
        }

        function isSecurityToggleDisabled() {
            return !helperService.hasSupportForE2EE() || self.isE2EEUsersLimitReached() || self.hostIsOnPhoneAudio();
        }

        function getSecurityToggleTooltip() {
            if (self.isHost) {
                if (!helperService.getVDIRef().isE2EESupported) {
                    return localizationService.translate('HEADER.SECURITY.TOOLTIP.CANNOT_ENABLE_E2EE_FOR_VDI', {
                        vdi: helperService.getVDIRef().getVdiType()
                    });
                }
                if (!helperService.hasSupportForE2EE()) {
                    return localizationService.translate('HEADER.SECURITY.TOOLTIP.CANNOT_ENABLE_E2EE');
                }

                if (self.isE2EEUsersLimitReached()) {
                    return localizationService.translate('HEADER.SECURITY.TOOLTIP.E2EE_MAX_USERS_REACHED', {
                        max_users: meetingService.getE2EEMaxUsers()
                    });
                }

                if (self.hostIsOnPhoneAudio()) {
                    return localizationService.translate('HEADER.SECURITY.TOOLTIP.E2EE_HOST_IS_ON_PHONE_AUDIO');
                }

                return meetingService.e2eeEnabled()
                    ? localizationService.translate('HEADER.SECURITY.TOOLTIP.DISABLE_E2EE')
                    : localizationService.translate('HEADER.SECURITY.TOOLTIP.ENABLE_E2EE');
            } else {
                return localizationService.translate('HEADER.SECURITY.TOOLTIP.E2EE_ENCRYPTED');
            }
        }

        function isE2EEUsersLimitReached() {
            return (
                !self.e2eeEnabled() &&
                attendeeListService.getAttendeeCountForE2EECondition() > meetingService.getE2EEMaxUsers()
            );
        }

        function e2eeEnabled() {
            return meetingService.e2eeEnabled();
        }

        function hasE2EEUnsupportedMobileAppUsers() {
            return (
                attendeeListService.getAttendeeList().filter(function (attendee) {
                    return attendee.isMobileAppUser && !attendee.supportsE2EE;
                }).length > 0
            );
        }

        function hostIsOnPhoneAudio() {
            return connectivityService.getAudioThroughPhone();
        }

        function onLayoutChangeControls(e, data) {
            logService.log('received videoroom-layout-controls ' + JSON.stringify(data));
            Object.assign(self.layoutControls, data);
            digest();
        }

        function selectCompactModeLayout() {
            if (onboardingService.isAppCuesModalOpen()) {
                return;
            }

            if (videoroomService.isLayoutInLargeGalleryView()) {
                analyticsWrapperService.eventTrack('Meeting - User Unselected All Webcams View Layout', {
                    category: 'Header menu'
                });
            }

            if (videoroomService.getCurrentLayout() === videoroomService.layouts.SPOTLIGHT) {
                $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.SPOTLIGHT });
            } else {
                $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.GALLERY });
            }
            analyticsWrapperService.eventTrack('Meeting - User Selected Compact Mode Layout', {
                category: 'Header menu'
            });
            $rootScope.$broadcast('enable-compact-mode', true);
            $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'device-dropdown' });
            $rootScope.$broadcast('enable-header-auto-hide', { enable: true, reason: 'header-popover' });
        }

        function selectSpotlightLayout() {
            if (videoroomService.isLayoutInLargeGalleryView()) {
                analyticsWrapperService.eventTrack('Meeting - User Unselected All Webcams View Layout', {
                    category: 'Header menu'
                });
            }

            analyticsWrapperService.eventTrack('Meeting - User Selected Spotlight View Layout', {
                category: 'Header menu'
            });

            $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.SPOTLIGHT });
        }

        function selectGalleryLayout() {
            if (videoroomService.isLayoutInLargeGalleryView()) {
                analyticsWrapperService.eventTrack('Meeting - User Unselected All Webcams View Layout', {
                    category: 'Header menu'
                });
            }

            analyticsWrapperService.eventTrack('Meeting - User Selected Gallery View Layout', {
                category: 'Header menu'
            });

            $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.GALLERY });
        }

        function selectLargeGalleryLayout() {
            analyticsWrapperService.eventTrack('Meeting - User Selected All Webcams View Layout', {
                category: 'Header menu'
            });

            $rootScope.$broadcast('change-videoroom-layout', { newLayout: videoroomService.layouts.ALLHANDS });
        }

        function toggleShowAllWebcamVideos() {
            $rootScope.$broadcast('toggle-feed-visibility', {
                type: videoroomService.feedType.SHOW_ALL_WEBCAM_VIDEOS,
                value: self.showAllWebcamVideos
            });
            if (!self.showAllWebcamVideos) {
                attendeeService.toggleVideoOff(
                    localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.YOU_CAMERA_TURNED_OFF')
                );
            }
        }

        function toggleShowSharedContent() {
            $rootScope.$broadcast('toggle-feed-visibility', {
                type: videoroomService.feedType.SHOW_SHARED_CONTENT,
                value: self.showSharedContent
            });
        }

        function shouldShowSharedContentToggle() {
            return contentService.isContentPlaying() && !self.isContentOwner;
        }

        function onStoppedVideosOnLoss() {
            self.showAllWebcamVideos = false;
            digest();
        }

        function shouldShowCurrentTalker() {
            return (
                meetingService.shouldShowCurrentTalker() &&
                attendeeListService.getCurrentTalkers() !== '' &&
                attendeeListService.getAttendeeList().length > 2
            );
        }

        function getCurrentTalkerNames() {
            return attendeeListService.getCurrentTalkers();
        }

        function onVirtualBackgroundStreamStarted(ev, data) {
            if (data.identifier == 'header') {
                self.webcamDevices.forEach(function (device) {
                    if (device.inUse) {
                        device.stream = data.stream;
                    }
                });
            }
        }

        function onVirtualBackgroundStreamError(ev, data) {
            if (data && data.identifier == 'header') {
                if (data.error) {
                    self.webcamDevices.forEach(function (device) {
                        if (device.inUse) {
                            device.stream = null;
                        }
                    });
                }
            }
        }

        function onE2EEEnabled() {
            $window.swal.close();
            clearQualityData();

            if (
                contentService.isContentPlaying() &&
                contentService.getIsFilePlay() &&
                contentService.getContentOwner() === self.attendantId
            ) {
                contentService.stopCurrentContent();
                logService.log('E2EE enabled - Calling stopCurrentContent');
            }
        }

        function hasThemedFeatures() {
            return (
                self.VDIRef.showThemedFeaturesButton &&
                themedFeaturesService.getThemedFeaturesAvailable() &&
                !helperService.isVideoRoomApplication()
            );
        }

        function toggleThemedFeatures() {
            let themedFeaturesEnabled = themedFeaturesService.getThemedFeaturesEnabled();

            //TODO Make this heap event
            logService.log(`Header - toggling themed features to ${!themedFeaturesEnabled}`);

            themedFeaturesService.setThemedFeaturesEnabled(!themedFeaturesEnabled);

            if (!themedFeaturesEnabled && localizationService.isEnLocale()) {
                onboardingService.showThemeFeaturesFlow();
            }

            if (themedFeaturesEnabled === false) {
                self.easterEggs = false;
                self.rabbit = false;
            }
        }

        function getThemedFeaturesTooltip() {
            if (themedFeaturesService.getThemedFeaturesEnabled()) {
                return themedFeaturesService.getThemeTooltips().disable;
            }

            return themedFeaturesService.getThemeTooltips().enable;
        }

        function isThemedFeaturesEnabled() {
            return themedFeaturesService.getThemedFeaturesEnabled() && !helperService.isVideoRoomApplication();
        }

        function getThemeType() {
            return themedFeaturesService.getThemeType();
        }

        function getThemeIcons() {
            const themeIcons = themedFeaturesService.getThemeIcons();

            if (isThemedFeaturesEnabled()) {
                return themeIcons.enabled;
            } else {
                return themeIcons.disabled;
            }
        }

        function getThemedReactions() {
            if (!self.themedReactions) {
                self.themedReactions = themedFeaturesService.getThemedReactions();
            }

            return self.themedReactions;
        }

        function getRecommendedTooltip() {
            return localizationService.translate('HEADER.SETTINGS.RECOMMENDED_DEVICE');
        }

        function handRaiseAvailable() {
            return self.getMeetingType() === 'meeting' && handRaiseService.handRaiseAvailable;
        }

        /**
         * @param value {boolean}
         */
        function onRaiseHandClick(value) {
            if (value) {
                handRaiseService.raiseHand(attendeeService.getAttendantId());
            } else {
                handRaiseService.lowerHand(attendeeService.getAttendantId());
            }
        }

        function attachTooltipHideListeners() {
            // Listener to hide tooltips on VDI after 1 second.
            logService.log('Attaching hide tooltip listener for VDI');

            var elementIds = [
                '#connectivity',
                '#connectionState',
                '#toggle-themed-features',
                '#toggle-recording',
                '#toggle-layout-icon',
                '#toggle-virtual-assistant',
                '#lock',
                '#security',
                '#toggle-more',
                '#open-support-site-icon',
                '#end-meeting',
                '#toggle-reaction',
                '#toggle-mic > .icon-tooltip-container',
                '#view-audio-options',
                '#toggle-cam > .icon-tooltip-container',
                '#view-video-options',
                '#share-desktop > .icon-tooltip-container',
                '#screen-share-options',
                '#sidebar-toggle-button-container'
            ];

            $window.$('body').on('show.bs.tooltip', elementIds, e => {
                $timeout(() => {
                    $window.$(e.target).tooltip('hide');
                }, 1000);
            });
        }

        function onEnableVideoOnReconnect(e, enable) {
            logger.log('onEnableVideoOnReconnect', `enable=${enable}; isVideoMuted=${self.isVideoMuted}`);

            if (!enable || (enable && self.isVideoMuted)) {
                self.toggleCamClick();
            }
        }

        function hideVideosInMeetingVDI() {
            $timeout(() => {
                if (!self.VDIRef.showContentsOnTopOfVideo && $window.Janus?.hideVideo) {
                    $window.Janus.hideVideo(true);
                }
            }, 300);
        }

        function showVideosInMeetingVDI() {
            if (!self.VDIRef.showContentsOnTopOfVideo && $window.Janus?.hideVideo) {
                $window.Janus.hideVideo(false);
                $rootScope.$broadcast('vdi-toggle-annotation-ui', false);
            }
        }

        function onCompactModeReceived(e, data) {
            self.isCompactMode = data;

            if (self.isCompactMode) {
                self.showAllWebcamVideos = true;
                self.showSharedContent = true;
                self.toggleShowAllWebcamVideos();
                self.toggleShowSharedContent();
            }
        }

        function disableCompactModeBtn() {
            $rootScope.$broadcast('enable-compact-mode', false);
        }

        function collapseCompactModeBtn() {
            if (helperService.isUniteApplication()) {
                $window.preloadedApi.remote.ipcRenderer.sendMinimizeCompactWindow();
            }
        }

        function getMinimizeToolTip() {
            return localizationService.translate('HEADER.TOOLTIP.COMPACT_MINIMIZE');
        }

        function getMaximizeToolTip() {
            return localizationService.translate('HEADER.TOOLTIP.COMPACT_MAXIMIZE');
        }

        function preloadImages() {
            for (let i = 0; i < arguments.length; i++) {
                images[i] = new Image();
                images[i].src = preloadImages.arguments[i];
            }
        }

        function onVDIMuteVideoOnDeviceChange(e, mute) {
            logger.log('onVDIMuteVideoOnDeviceChange', `mute=${mute}; isVideoMuted=${self.isVideoMuted}`);

            if (mute && !self.isVideoMuted) {
                self.toggleCamClick();
            }
        }

        function onVDITogglePreviewVideoVisibility(e, value) {
            const previewElement = $window.$('#video-preview')[0];
            if (!self.VDIRef.showContentsOnTopOfVideo && previewElement) {
                previewElement.style.display = value ? 'none' : '';
            }
        }

        function shouldCloseWebcamDropdown() {
            if (!self.VDIRef.showContentsOnTopOfVideo) {
                return self.isWebcamAvailable && self.devicesLoading['videoInput'];
            } else {
                return self.devicesLoading['videoInput'];
            }
        }

        function onScreenShareInitCancelled() {
            self.resetScreenShareReadyToInitialize();
        }

        function onScreenSharePresenterStarted() {
            self.resetScreenShareReadyToInitialize();
        }

        function resetScreenShareReadyToInitialize() {
            if (self.VDIRef.preventScreenShareStartIfAlreadyInitializing) {
                self.isScreenShareReadyToInitialize = false;
            }
        }

        function hasShareVideo() {
            return (
                helperService.browserHasWebRTC() &&
                helperService.hasCaptureStream('video') &&
                self.VDIRef.showShareVideoOption
            );
        }

        function onToastNotification(e, data) {
            if (data.show) {
                self.toastNotificationMessage = data.message;
                self.showToastNotification = data.show;
            } else {
                self.toastDismiss();
            }
        }

        function toastDismiss() {
            self.showToastNotification = false;
        }

        function isAudioDisconnected() {
            return avDeviceService.isAudioDisconnected();
        }

        function toggleMuteAudioInputAndOutput() {
            if (self.phoneOnlyState) {
                analyticsWrapperService.eventTrack('Meeting - Switch from phone audio to no audio', {
                    category: 'Header menu'
                });
            }

            if (self.isAudioDisconnected()) {
                analyticsWrapperService.eventTrack('Meeting - Switch from no audio to computer audio', {
                    category: 'Header menu'
                });
            } else {
                analyticsWrapperService.eventTrack('Meeting - Switch from computer audio to no audio', {
                    category: 'Header menu'
                });
            }

            self.showAudioDisconnectDialog();
            digest();
        }

        function getEnableAudioDisconnect() {
            return meetingService.getEnableAudioDisconnect();
        }

        function shouldODALiveChat() {
            return customerSupportService.canUseODACustomerService() && !helperService.isVideoRoomApplication();
        }

        function openODACustomerSupport() {
            if (!self.isODAAgentsAvailable && !Bots.isChatOpened()) {
                return;
            }

            Bots.openChat();
        }

        function getLiveAssistantTooltip() {
            if (self.isODAAgentsAvailable) {
                return localizationService.translate('HEADER.TOOLTIP.LIVE_ASSISTANT_ONLINE');
            } else {
                return localizationService.translate('HEADER.TOOLTIP.LIVE_ASSISTANT_OFFLINE');
            }
        }

        function updateODATotalAvailableAgents(e, availAgents) {
            if (availAgents > 0) {
                self.isODAAgentsAvailable = true;
            } else {
                self.isODAAgentsAvailable = false;
            }
        }

        function qualityDataUpdated(e, data) {
            self.qualityData = data.qualityData;
            digest();
        }

        // do not show in header if no data available or max quality value.
        function shouldShowQualityBars() {
            const value = self.qualityData?.value;
            return meetingService.getHasQualityBars() && !meetingService.e2eeEnabled() && value && value !== '4';
        }

        function shouldShowOldQualityIndicator() {
            return !meetingService.getHasQualityBars() || meetingService.e2eeEnabled();
        }

        function getQualityIcon() {
            switch (self.qualityData?.value) {
                case '4':
                    return 'img/redesign/icons/quality-bars/ic-connection-4-bars-24.svg';
                case '3':
                    return 'img/redesign/icons/quality-bars/ic-connection-3-bars-24.svg';
                case '2':
                    return 'img/redesign/icons/quality-bars/ic-connection-2-bars-24.svg';
                case '1':
                    return 'img/redesign/icons/quality-bars/ic-connection-1-bar-24.svg';
                case '0':
                    return 'img/redesign/icons/quality-bars/ic-connection-no-24.svg';
                default:
                    return '';
            }
        }

        function clearQualityData() {
            self.qualityData = {};
        }

        function onNodeReconnected() {
            clearQualityData();
        }
    }
]);
